import axios from "axios";
import React from "react";
import Moment from "react-moment";
import Swal from "sweetalert2";
import config from "../../config";
import Footer from "./Footer";
import Header from "./Header";
import ShippingProgressBar from "./setShipNowOpen";

const Orders = () => {
  const getDefaultDateRange = () => {
    const today = new Date();

    const fromDate = new Date(today);
    fromDate.setMonth(fromDate.getMonth() - 6);

    return {
      from: fromDate.toISOString().split("T")[0],
      to: today.toISOString().split("T")[0],
    };
  };
  const [dateRange, setDateRange] = React.useState(getDefaultDateRange);
  const [allOrderData, setAllOrderData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalCount, setTotalCount] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [activeTab, setActiveTab] = React.useState("new");
  const [selectedIds, setSelectedIds] = React.useState([]);
  console.log("selectedIds === ", selectedIds);

  const [tabCounts, setTabCounts] = React.useState({});
  const [showShipModal, setShowShipModal] = React.useState(false);
  const [shipMode, setShipMode] = React.useState("manual");
  const [selectedCourier, setSelectedCourier] = React.useState(null);
  const [shippingRules, setShippingRules] = React.useState([]);
  const [shippingRulesLoading, setShippingRulesLoading] = React.useState(false);

  const [showWarehouseModal, setShowWarehouseModal] = React.useState(false);
  const [showDimensionsModal, setShowDimensionsModal] = React.useState(false);
  const [shipStep, setShipStep] = React.useState(1);

  const [customerAllocate, setCustomerAllocate] = React.useState(0);
  const [openFilter, setOpenFilter] = React.useState(null);
  const emptyFilters = {
    warehouse: [],
    channel: [],
    courier: [],
    payment_mode: [],
    order_type: [],
    zone: [],
    weight_min: "",
    weight_max: "",
    cod_min: "",
    cod_max: "",
  };

  const [filters, setFilters] = React.useState(emptyFilters);

  const [searchInput, setSearchInput] = React.useState("");

  const [appliedSearch, setAppliedSearch] = React.useState("");

  const [showFilters, setShowFilters] = React.useState(false);
  const [warehouses, setWarehouses] = React.useState([]);
  const [courierPartners, setCourierPartners] = React.useState([]);
  const [selectedOrder, setSelectedOrder] = React.useState(null);

  const [detailDrawerOpen, setDetailDrawerOpen] = React.useState(false);

  const [shipNowOrder, setShipNowOrder] = React.useState(null);

  const [shipNowOpen, setShipNowOpen] = React.useState(false);

  const [actionMenuItem, setActionMenuItem] = React.useState(null);
  // const [actionMenuOpen, setActionMenuOpen] = React.useState(false);
  const [trackingHistory, setTrackingHistory] = React.useState([]);
  const [trackingLoading, setTrackingLoading] = React.useState(false);
  const [actionMenuPosition, setActionMenuPosition] = React.useState({
    top: 0,
    left: 0,
  });
  const [courierOffers, setCourierOffers] = React.useState([]);

  const [courierLoading, setCourierLoading] = React.useState(false);

  const [courierSort, setCourierSort] = React.useState("recommended");

  const [shippingLoading, setShippingLoading] = React.useState(false);
  const [showSkuModal, setShowSkuModal] = React.useState(false);
  const [bulkShipOrders, setBulkShipOrders] = React.useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = React.useState("");

  const [bulkWeight, setBulkWeight] = React.useState("");

  const [bulkLength, setBulkLength] = React.useState("");

  const [bulkWidth, setBulkWidth] = React.useState("");

  const [bulkHeight, setBulkHeight] = React.useState("");

  const [bulkSku, setBulkSku] = React.useState("");

  const [bulkActionLoading, setBulkActionLoading] = React.useState(false);
  const actionMenuOpen = !!actionMenuItem;

  React.useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".ol-mselect")) {
        setOpenFilter(null);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  React.useEffect(() => {
    const handleOutsideClick = () => {
      setActionMenuItem(null);
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  React.useEffect(() => {
    const handleClose = () => {
      setActionMenuItem(null);
    };

    window.addEventListener("resize", handleClose);
    window.addEventListener("scroll", handleClose, true);

    return () => {
      window.removeEventListener("resize", handleClose);
      window.removeEventListener("scroll", handleClose, true);
    };
  }, []);

  const handleDateChange = (field, value) => {
    setDateRange((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getShippingRules = async () => {
    try {
      setShippingRulesLoading(true);

      const userDetail = localStorage.getItem("ship_rocket_user");

      const userData = userDetail ? JSON.parse(userDetail) : {};

      const response = await axios.post(
        `${config.apiUrl}/shipping_rule/list`,
        {
          customer_id: userData.customer_id,
          status: "active",
        },
        {
          headers: config.headers,
        }
      );

      if (response.data?.status === true) {
        setShippingRules(
          Array.isArray(response.data.output) ? response.data.output : []
        );
      } else {
        setShippingRules([]);
      }
    } catch (error) {
      console.error("getShippingRules error =>", error);

      setShippingRules([]);
    } finally {
      setShippingRulesLoading(false);
    }
  };
  const getOrders = async ({
    pageNumber = page,
    rows = rowsPerPage,
    searchValue = appliedSearch,
    filterValues = filters,
    tab = activeTab,
  } = {}) => {
    try {
      setIsLoading(true);

      const userDetail = localStorage.getItem("ship_rocket_user");

      let userData = {};

      if (userDetail) {
        userData = JSON.parse(userDetail);
      }

      const dataToSend = {
        customer_id: userData.customer_id,

        // Current tab
        tab,

        // Pagination
        limit: rows,
        indexValue: pageNumber,

        // Search
        find: searchValue,

        // Date
        from_date: dateRange.from,
        to_date: dateRange.to,

        // Filters
        warehouse: filterValues.warehouse || [],
        channel: filterValues.channel || [],
        courier: filterValues.courier || [],
        payment_mode: filterValues.payment_mode || [],
        order_type: filterValues.order_type || [],
        zone: filterValues.zone || [],

        weight_min: filterValues.weight_min ?? "",

        weight_max: filterValues.weight_max ?? "",

        cod_min: filterValues.cod_min ?? "",

        cod_max: filterValues.cod_max ?? "",
      };

      console.log("customer_orders_combined payload =>", dataToSend);

      const url = config.apiUrl + "/shipment/customer_orders_combined";

      const response = await axios.post(url, dataToSend, {
        headers: config.headers,
      });

      console.log("customer_orders_combined response =>", response.data);

      if (response.data?.status === true) {
        const data = Array.isArray(response.data.output)
          ? response.data.output
          : [];

        setAllOrderData(data);

        // Total records for pagination
        setTotalCount(Number(response.data.count || 0));

        // Keep counts if backend sends them
        setTabCounts(response.data.tab_counts || {});
      } else {
        setAllOrderData([]);
        setTotalCount(0);
        setTabCounts({});
      }
    } catch (error) {
      console.error("customer_orders_combined error =>", error);

      setAllOrderData([]);
      setTotalCount(0);
      setTabCounts({});

      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: error?.response?.data?.message || "Unable to fetch orders.",
      });
    } finally {
      setIsLoading(false);
    }
  };
  React.useEffect(() => {
    getOrders({
      pageNumber: 0,
      rows: rowsPerPage,
      tab: activeTab,
    });
    getWarehouses();
    getCourierPartners();
  }, []);

  const getTabRows = React.useMemo(() => {
    switch (activeTab) {
      case "all":
        return allOrderData;

      case "new":
        return allOrderData.filter((item) => item.record_type === "order");

      case "pua":
        return allOrderData.filter(
          (item) =>
            item.record_type === "shipment" &&
            [1, 9].includes(Number(item.status))
        );

      case "picked_up":
        return allOrderData.filter(
          (item) => item.record_type === "shipment" && Number(item.status) === 2
        );

      case "in_transit":
        return allOrderData.filter(
          (item) => item.record_type === "shipment" && Number(item.status) === 3
        );

      case "ofd":
        return allOrderData.filter(
          (item) => item.record_type === "shipment" && Number(item.status) === 4
        );

      case "delivered":
        return allOrderData.filter(
          (item) => item.record_type === "shipment" && Number(item.status) === 5
        );

      case "ndr":
        return allOrderData.filter(
          (item) => item.record_type === "shipment" && Number(item.status) === 8
        );

      case "failed":
        return allOrderData.filter(
          (item) => item.record_type === "shipment" && Number(item.status) === 7
        );

      case "rto_transit":
        return allOrderData.filter(
          (item) =>
            item.record_type === "shipment" &&
            [10, 19].includes(Number(item.status))
        );

      case "rto_delivered":
        return allOrderData.filter(
          (item) =>
            item.record_type === "shipment" && Number(item.status) === 16
        );

      case "cancelled":
        return allOrderData.filter(
          (item) => item.record_type === "shipment" && Number(item.status) === 6
        );

      default:
        return [];
    }
  }, [allOrderData, activeTab]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPage(0);
    setSelectedIds([]);
    getOrders({
      tab,
      pageNumber: 0,
      rows: rowsPerPage,
    });
  };
  const ORDER_TABS = [
    {
      key: "all",
      label: "All",
      icon: "bi-collection",
    },
    {
      key: "new",
      label: "New",
      icon: "bi-send",
    },
    {
      key: "pua",
      label: "PUA",
      icon: "bi-hourglass-split",
    },
    {
      key: "picked_up",
      label: "Picked Up",
      icon: "bi-box-arrow-in-up",
    },
    {
      key: "in_transit",
      label: "In Transit",
      icon: "bi-truck",
    },
    {
      key: "ofd",
      label: "Out For Delivery",
      icon: "bi-box-seam",
    },
    {
      key: "delivered",
      label: "Delivered",
      icon: "bi-check2-circle",
    },
    {
      key: "ndr",
      label: "NDR",
      icon: "bi-exclamation-triangle",
    },
    {
      key: "failed",
      label: "Failed",
      icon: "bi-x-circle",
    },
    {
      key: "rto_transit",
      label: "RTO In Transit",
      icon: "bi-arrow-return-right",
    },
    {
      key: "rto_delivered",
      label: "RTO Delivered",
      icon: "bi-arrow-return-left",
    },
    {
      key: "cancelled",
      label: "Cancelled",
      icon: "bi-x-octagon",
    },
  ];
  const ORDER_SUMMARY = [
    {
      key: "all",
      label: "Total Orders",
      icon: "bi-boxes",
      accent: "a-blue",
    },
    {
      key: "new",
      label: "New",
      icon: "bi-plus-circle",
      accent: "a-sky",
    },
    {
      key: "pua",
      label: "PUA",
      icon: "bi-hourglass-split",
      accent: "a-amber",
    },
    {
      key: "in_transit",
      label: "In Transit",
      icon: "bi-truck",
      accent: "a-violet",
    },
    {
      key: "ofd",
      label: "OFD",
      icon: "bi-box-seam",
      accent: "a-amber",
    },
    {
      key: "delivered",
      label: "Delivered",
      icon: "bi-check2-circle",
      accent: "a-green",
    },
    {
      key: "ndr",
      label: "NDR",
      icon: "bi-exclamation-triangle",
      accent: "a-red",
    },
    {
      key: "failed",
      label: "Failed",
      icon: "bi-x-circle",
      accent: "a-red",
    },
    {
      key: "rto_transit",
      label: "RTO In Transit",
      icon: "bi-arrow-return-right",
      accent: "a-red",
    },
    {
      key: "rto_delivered",
      label: "RTO Delivered",
      icon: "bi-arrow-return-left",
      accent: "a-red",
    },

    {
      key: "cancelled",
      label: "Cancelled",
      icon: "bi-x-octagon",
      accent: "a-slate",
    },
  ];
  const paginatedRows = React.useMemo(() => {
    const start = page * rowsPerPage;

    return getTabRows.slice(start, start + rowsPerPage);
  }, [getTabRows, page, rowsPerPage]);

  const currentTabCount = getTabRows.length;

  const filterCount = React.useMemo(() => {
    let count = 0;

    if (filters.warehouse.length) count++;
    if (filters.channel.length) count++;
    if (filters.courier.length) count++;
    if (filters.payment_mode.length) count++;
    if (filters.order_type.length) count++;
    if (filters.zone.length) count++;

    if (filters.weight_min !== "" || filters.weight_max !== "") {
      count++;
    }

    if (filters.cod_min !== "" || filters.cod_max !== "") {
      count++;
    }

    return count;
  }, [filters]);

  const updateMultiSelect = (key, value, checked) => {
    setFilters((prev) => ({
      ...prev,
      [key]: checked
        ? [...prev[key], value]
        : prev[key].filter((item) => item !== value),
    }));
  };
  const getWarehouses = async () => {
    try {
      const response = await axios.post(
        `${config.apiUrl}/shipment/getAllWarehouse`,
        {},
        {
          headers: config.headers,
        }
      );

      if (response.data?.status === true) {
        setWarehouses(
          Array.isArray(response.data.output) ? response.data.output : []
        );
      } else {
        setWarehouses([]);
      }
    } catch (error) {
      console.error("getAllWarehouse error =>", error);

      setWarehouses([]);
    }
  };
  const getCourierPartners = async () => {
    try {
      const response = await axios.post(
        `${config.apiUrl}/shipment/all_product_list`,
        {
          mode: "Domestic",
          order_type: "Forward",
        },
        {
          headers: config.headers,
        }
      );

      if (
        response.data?.status === true ||
        response.data?.status === "success"
      ) {
        const output = Array.isArray(response.data.output)
          ? response.data.output
          : [];

        /*
         * Remove duplicate products/couriers.
         */
        const unique = output.filter((item, index, array) => {
          const key = item.product_id || item.carrier_id || item.product_name;

          return (
            index ===
            array.findIndex((x) => {
              const otherKey = x.product_id || x.carrier_id || x.product_name;

              return otherKey === key;
            })
          );
        });

        setCourierPartners(unique);
      } else {
        setCourierPartners([]);
      }
    } catch (error) {
      console.error("all_product_list error =>", error);

      setCourierPartners([]);
    }
  };

  const getChannelName = (item) => {
    if (item?.channel_id === "1567898605") {
      return "Shopify";
    }

    if (item?.channel_id === "1507808901") {
      return "WooCommerce";
    }

    return "Direct Sales";
  };

  const getStatusLabel = (item) => {
    if (item?.record_type === "order") {
      return "New";
    }

    switch (Number(item?.status)) {
      case 1:
        return "Pickup Awaited";

      case 9:
        return "Pickup Scheduled";

      case 2:
        return "Picked Up";

      case 3:
        return "In Transit";

      case 4:
        return "Out For Delivery";

      case 5:
        return "Delivered";

      case 6:
        return "Cancelled";

      case 7:
        return "Failed";

      case 8:
        return "NDR";

      case 10:
      case 19:
        return "RTO In Transit";

      case 16:
        return "RTO Delivered";

      default:
        return "—";
    }
  };

  const getStatusClass = (item) => {
    if (item?.record_type === "order") {
      return "blue";
    }

    switch (Number(item?.status)) {
      case 5:
        return "green";

      case 7:
      case 6:
        return "red";

      case 8:
        return "amber";

      case 10:
      case 16:
      case 19:
        return "purple";

      case 1:
      case 9:
        return "amber";

      default:
        return "blue";
    }
  };

  const getCustomerName = (item) => {
    return item?.receiver?.[0]?.name || "—";
  };

  const getCustomerMobile = (item) => {
    return item?.receiver?.[0]?.mobile || "";
  };

  const getDestination = (item) => {
    const receiver = item?.receiver?.[0];

    if (!receiver) {
      return {
        city: "—",
        location: "",
      };
    }

    return {
      city: receiver.city || "—",
      location: [receiver.state, receiver.pincode].filter(Boolean).join(" · "),
    };
  };

  const getCourierName = (item) => {
    return (
      item?.service_provider || item?.carrier_name || item?.courier_name || "—"
    );
  };

  const getPaymentType = (item) => {
    return item?.payment_mode === "cod" ? "COD" : "Prepaid";
  };

  const getCodAmount = (item) => {
    if (item?.payment_mode !== "cod") {
      return "—";
    }

    return `₹${Number(item?.cod_amount || 0).toFixed(2)}`;
  };

  const getShippingCharges = (item) => {
    const amount =
      item?.total_charges ??
      item?.shipping_charges ??
      item?.rate_price ??
      item?.total_amount ??
      0;

    return `₹${Number(amount || 0).toFixed(2)}`;
  };

  const getWeight = (item) => {
    return Number(item?.total_weight ?? item?.dead_weight ?? 0).toFixed(2);
  };

  const getDimensions = (item) => {
    const length = item?.length ?? 0;
    const width = item?.width ?? 0;
    const height = item?.height ?? 0;

    return `${length} × ${width} × ${height}`;
  };

  const openOrderDetails = async (item) => {
    setSelectedOrder(item);
    setDetailDrawerOpen(true);
    if (item?.record_type === "shipment") {
      await getShipmentTracking(item);
    } else {
      setTrackingHistory([]);
    }
  };

  const closeOrderDetails = () => {
    setDetailDrawerOpen(false);
    setSelectedOrder(null);
  };

  const openShipNow = async (item) => {
    if (!item) return;

    setShipNowOrder(item);
    setShipNowOpen(true);
    setCourierOffers([]);
    setCourierSort("recommended");

    await getCourierOffers(item);
  };

  const closeShipNow = () => {
    if (shippingLoading) {
      return;
    }

    setShipNowOpen(false);
    setShipNowOrder(null);
    setCourierOffers([]);
  };

  const openActionMenu = (item, event) => {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();

    const actions = getRowActions(item);

    const menuWidth = 310;

    const menuHeight = actions.reduce((height, action) => {
      if (action.type === "heading") {
        return height + 32;
      }

      if (action.type === "separator") {
        return height + 21;
      }

      return height + 52;
    }, 20);

    let left = rect.right - menuWidth;
    let top = rect.bottom + 8;

    // Right boundary
    if (left + menuWidth > window.innerWidth - 10) {
      left = window.innerWidth - menuWidth - 10;
    }

    // Left boundary
    if (left < 10) {
      left = 10;
    }

    // Bottom boundary
    if (top + menuHeight > window.innerHeight - 10) {
      top = rect.top - menuHeight - 8;
    }

    // Top boundary
    if (top < 10) {
      top = 10;
    }

    setActionMenuPosition({
      top,
      left,
    });

    setActionMenuItem(item);
  };
  const closeActionMenu = () => {
    setActionMenuItem(null);
  };

  const courierLogoMap = {
    BlueDart: "assets/images/carrier_logo/bluedart.webp",
    Delhivery: "assets/images/carrier_logo/delhivery.webp",
    DTDC: "assets/images/carrier_logo/dtdc.webp",
    FedEx: "assets/images/carrier_logo/fedex.webp",
    Amazon: "assets/images/carrier_logo/amazon.webp",
  };

  const channelLogoMap = {
    Shopify: "assets/img/shopify.png",
    WooCommerce: "assets/img/woo.png",
    "Direct Sales": "assets/img/dire_sales.png",
    Amazon: "assets/images/carrier_logo/amazon.webp",
  };

  const money = (value) => {
    const amount = Number(value || 0);
    return `₹${amount.toFixed(2)}`;
  };

  const getCourierValue = (item) =>
    item?.service_provider || item?.courier_name || item?.carrier_name || "";

  const getChannelValue = (item) => {
    if (item?.channel_id === "1567898605") return "Shopify";
    if (item?.channel_id === "1507808901") return "WooCommerce";
    return "Direct Sales";
  };
  const renderCustomer = (item) => {
    const customer = item?.receiver?.[0] || {};

    return (
      <span className="ol-cust">
        <span className="ol-cust-top">
          <span className="ol-cust-name">{customer.name || "—"}</span>

          <span className="ol-cust-acts">
            {customer.mobile && (
              <>
                <button
                  type="button"
                  className="ca"
                  title="Call"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.location.href = `tel:${customer.mobile}`;
                  }}
                >
                  <i className="bi bi-telephone"></i>
                </button>

                <button
                  type="button"
                  className="ca"
                  title="Copy phone"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard?.writeText(customer.mobile);
                  }}
                >
                  <i className="bi bi-clipboard"></i>
                </button>
              </>
            )}
          </span>
        </span>

        <span className="ol-sub ol-mono">{customer.mobile || ""}</span>

        {item?.customer_company && (
          <span className="ol-sub">{item.customer_company}</span>
        )}
      </span>
    );
  };
  const renderChannel = (item) => {
    const channel = getChannelValue(item);
    const logo = channelLogoMap[channel] || "assets/img/dire_sales.png";

    return (
      <span className="ol-ch-cell">
        <img className="ol-ch-logo" src={logo} alt={channel} title={channel} />

        <span className="ol-ch-name">{channel}</span>
      </span>
    );
  };
  const renderCourier = (item) => {
    if (item?.record_type === "order") {
      return null;
    }

    const courier = getCourierValue(item);

    if (!courier) {
      return null;
    }

    const logo = courierLogoMap[courier];

    if (logo) {
      return (
        <span className="ol-car-wrap">
          <img
            className="ol-car-logo"
            src={logo}
            alt={courier}
            title={courier}
          />
        </span>
      );
    }

    return (
      <span className="ol-courier-logo ol-courier-fallback" title={courier}>
        {courier}
      </span>
    );
  };
  const renderOrderDateTime = (item) => {
    if (item?.record_type === "order") {
      return (
        <>
          {item?.order_date && (
            <Moment format="MMM DD YYYY">{item.order_date}</Moment>
          )}

          {item?.order_created && (
            <>
              {" · "}
              <Moment format="hh:mm A">
                {new Date(Number(item.order_created) * 1000)}
              </Moment>
            </>
          )}
        </>
      );
    }

    if (item?.created) {
      const createdDate = new Date(Number(item.created) * 1000);

      return (
        <>
          <Moment format="MMM DD YYYY">{createdDate}</Moment>
          {" · "}
          <Moment format="hh:mm A">{createdDate}</Moment>
        </>
      );
    }

    return "—";
  };

  const formatDrawerDate = (value) => {
    if (!value) return "—";

    const date = value instanceof Date ? value : new Date(value);

    if (Number.isNaN(date.getTime())) {
      return "—";
    }

    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatDrawerDateTime = (value) => {
    if (!value) return "—";

    const date = value instanceof Date ? value : new Date(value);

    if (Number.isNaN(date.getTime())) {
      return "—";
    }

    return (
      date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
      }) +
      ", " +
      date.toLocaleTimeString("en-IN", {
        hour: "numeric",
        minute: "2-digit",
      })
    );
  };

  const getCreatedDate = (item) => {
    if (item?.record_type === "shipment") {
      if (item?.created) {
        return new Date(Number(item.created) * 1000);
      }

      if (item?.order_created) {
        return new Date(Number(item.order_created) * 1000);
      }
    }

    if (item?.order_created) {
      return new Date(Number(item.order_created) * 1000);
    }

    if (item?.order_date) {
      return new Date(item.order_date);
    }

    return null;
  };

  const getAwbCreatedDate = (item) => {
    if (item?.awb_created) {
      return new Date(Number(item.awb_created) * 1000);
    }

    if (item?.created) {
      return new Date(Number(item.created) * 1000);
    }

    return null;
  };

  const getDrawerCourier = (item) => {
    return (
      item?.service_provider || item?.courier_name || item?.carrier_name || "—"
    );
  };

  const getDrawerService = (item) => {
    return (
      item?.service_name ||
      item?.product_type_name ||
      item?.service_provider ||
      "—"
    );
  };

  const getDrawerWarehouse = (item) => {
    return item?.warehouse_id || item?.warehouse_name || "—";
  };

  const getDrawerDestination = (item) => {
    const receiver = item?.receiver?.[0] || {};

    return {
      city: receiver.city || "—",
      state: receiver.state || "—",
      pincode: receiver.pincode || "—",
    };
  };

  const getDrawerCustomer = (item) => {
    const receiver = item?.receiver?.[0] || {};

    return {
      name: receiver.name || "—",
      phone: receiver.mobile || "—",
      email: receiver.email || "—",
      address: receiver.address || "—",
      city: receiver.city || "",
      state: receiver.state || "",
      pincode: receiver.pincode || "",
    };
  };

  const getDrawerCompany = (item) => {
    return (
      item?.customer_company ||
      item?.company_name ||
      item?.receiver_company ||
      "—"
    );
  };

  const getDrawerPayment = (item) => {
    return item?.payment_mode === "cod" ? "COD" : "Prepaid";
  };

  const getDrawerCod = (item) => {
    return item?.payment_mode === "cod"
      ? `₹${Number(item?.cod_amount || 0).toFixed(2)}`
      : "—";
  };

  const getDrawerCharges = (item) => {
    const amount =
      item?.total_charges ??
      item?.shipping_charges ??
      item?.rate_price ??
      item?.total_amount;

    return amount === undefined || amount === null || amount === ""
      ? "—"
      : `₹${Number(amount).toFixed(2)}`;
  };

  const getDrawerWeight = (item) => {
    return `${Number(item?.total_weight ?? item?.dead_weight ?? 0).toFixed(
      2
    )} kg`;
  };

  const getDrawerVolumetricWeight = (item) => {
    return `${Number(item?.volumetric_weight || 0).toFixed(2)} kg`;
  };

  const getDrawerItems = (item) => {
    return Array.isArray(item?.items) ? item.items : [];
  };

  const getDrawerItemTotal = (product) => {
    const qty = Number(product?.item_quantity || 0);

    const price = Number(product?.item_value || 0);

    return qty * price;
  };
  const getTrackingEvents = (item) => {
    if (Array.isArray(item?.tracking_history)) {
      return item.tracking_history;
    }

    if (Array.isArray(item?.tracking_events)) {
      return item.tracking_events;
    }

    if (Array.isArray(item?.tracking)) {
      return item.tracking;
    }

    return [];
  };
  const DrawerRow = ({ label, value, full = false }) => {
    if (value === "" || value === null || value === undefined) {
      return null;
    }

    return (
      <div className={`df ${full ? "full" : ""}`}>
        <span>{label}</span>
        <b>{value}</b>
      </div>
    );
  };

  const getShipmentTracking = async (shipment) => {
    if (!shipment) return;

    try {
      setTrackingLoading(true);
      setTrackingHistory([]);

      const userDetail = localStorage.getItem("ship_rocket_user");

      const userData = userDetail ? JSON.parse(userDetail) : {};

      const payload = {
        customer_id: userData.customer_id,
        shipment_id: shipment.shipment_id,
        carrier_tracking_number:
          shipment.carrier_tracking_number || shipment.awb || "",
      };

      const url = config.apiUrl + "/shipment/shipment_tracking";

      const response = await axios.post(url, payload, {
        headers: config.headers,
      });

      console.log("shipment_tracking response =>", response.data);

      const tracking =
        response.data?.output ||
        response.data?.tracking ||
        response.data?.data ||
        [];

      setTrackingHistory(Array.isArray(tracking) ? tracking : []);
    } catch (error) {
      console.error("shipment_tracking error =>", error);

      setTrackingHistory([]);
    } finally {
      setTrackingLoading(false);
    }
  };

  const handleTrackShipment = (shipment) => {
    if (!shipment?.shipment_id) {
      Swal.fire({
        icon: "warning",
        text: "Shipment ID is not available.",
      });
      return;
    }

    window.open(
      `/tracking/${shipment.shipment_id}`,
      "_blank",
      "noopener,noreferrer"
    );
  };
  const handlePrintLabel = (shipment) => {
    if (!shipment?.shipment_id) {
      Swal.fire({
        icon: "warning",
        text: "Shipment ID is not available.",
      });
      return;
    }

    window.open(
      `/print_label?id=${shipment.shipment_id}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const getRowActions = (item) => {
    // =====================================================
    // ORDER
    // =====================================================
    if (item?.record_type === "order") {
      return [
        {
          type: "heading",
          label: "Order",
        },
        {
          key: "view",
          label: "View Order",
          icon: "bi-eye",
        },
        {
          key: "edit",
          label: "Edit Order",
          icon: "bi-pencil",
        },
        {
          key: "clone",
          label: "Clone Order",
          icon: "bi-copy",
        },
        {
          key: "copy_address",
          label: "Copy Address",
          icon: "bi-geo-alt",
        },
        {
          type: "separator",
        },
        {
          key: "delete_order",
          label: "Delete Order",
          icon: "bi-x-octagon",
          danger: true,
        },
      ];
    }

    // =====================================================
    // SHIPMENT
    // =====================================================

    const status = Number(item?.status);

    const actions = [
      {
        type: "heading",
        label: "Order",
      },
      {
        key: "view",
        label: "View Order",
        icon: "bi-eye",
      },
    ];

    // Update Status
    // Do not show after Delivered / RTO Delivered / Cancelled
    if (![5, 16, 6].includes(status)) {
      actions.push({
        key: "update_status",
        label: "Update Status",
        icon: "bi-arrow-repeat",
      });
    }

    // =====================================================
    // SHIPPING
    // =====================================================

    actions.push({
      type: "separator",
    });

    actions.push({
      type: "heading",
      label: "Shipping",
    });

    actions.push({
      key: "label",
      label: "Generate Label",
      icon: "bi-tag",
    });

    actions.push({
      key: "invoice",
      label: "Download Invoice",
      icon: "bi-receipt",
    });

    actions.push({
      key: "track",
      label: "Track Order",
      icon: "bi-radar",
    });

    // =====================================================
    // DELIVERY
    // =====================================================

    actions.push({
      type: "separator",
    });

    actions.push({
      key: "ndr",
      label: "Raise NDR",
      icon: "bi-exclamation-triangle",
    });

    actions.push({
      key: "reattempt",
      label: "Reattempt Delivery",
      icon: "bi-arrow-return-left",
    });

    actions.push({
      key: "copy_address",
      label: "Copy Address",
      icon: "bi-geo-alt",
    });

    // =====================================================
    // OTHER
    // =====================================================

    actions.push({
      type: "separator",
    });

    actions.push({
      key: "clone",
      label: "Clone Order",
      icon: "bi-copy",
    });

    // Cancel only for Pickup Awaited / Pickup Scheduled
    if ([1, 9].includes(status)) {
      actions.push({
        key: "cancel_shipment",
        label: "Cancel Order",
        icon: "bi-x-octagon",
        danger: true,
      });
    }

    return actions;
  };

  const handleRowAction = (action, item) => {
    if (!item || !action) {
      return;
    }

    // Close menu first
    closeActionMenu();

    switch (action) {
      // ==========================================
      // ORDER
      // ==========================================

      case "view":
        openOrderDetails(item);
        break;

      case "edit":
        handleEditOrder(item);
        break;

      case "clone":
        handleCloneOrder(item);
        break;

      case "copy_address":
        handleCopyAddress(item);
        break;

      case "delete_order":
        handleDeleteOrder(item);
        break;

      // ==========================================
      // SHIPPING
      // ==========================================

      case "update_status":
        handleUpdateStatus(item);
        break;

      case "label":
        handlePrintLabel(item);
        break;

      case "invoice":
        handleInvoice(item);
        break;

      case "track":
        handleTrackShipment(item);
        break;

      // ==========================================
      // DELIVERY
      // ==========================================

      case "ndr":
        console.log("Raise NDR", item);

        // Add your NDR function here when available
        break;

      case "reattempt":
        console.log("Reattempt Delivery", item);

        // Add your reattempt function here when available
        break;

      // ==========================================
      // SHIPMENT
      // ==========================================

      case "cancel_shipment":
        handleCancelShipment(item);
        break;

      default:
        console.warn("Unknown row action:", action, item);
        break;
    }
  };
  const handleCopyAddress = async (item) => {
    const receiver = item?.receiver?.[0] || {};

    const address = [
      receiver.name,
      receiver.address,
      receiver.city,
      receiver.state,
      receiver.pincode,
      receiver.mobile,
    ]
      .filter(Boolean)
      .join(", ");

    try {
      await navigator.clipboard.writeText(address);

      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "success",
        title: "Address copied",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error("Copy address failed:", error);
    }
  };

  const handleDeleteOrder = async (item) => {
    if (!item?.order_number) return;

    const result = await Swal.fire({
      icon: "warning",
      title: "Delete Order?",
      text: `Are you sure you want to delete ${item.order_number}?`,
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const response = await axios.post(
        `${config.apiUrl}/shipment/cancel_order`,
        {
          order_id: item.order_number,
          dstatus: 3,
        },
        {
          headers: config.headers,
        }
      );

      if (response.data?.status === true) {
        Swal.fire({
          toast: true,
          position: "bottom-end",
          icon: "success",
          title: "Order deleted",
          showConfirmButton: false,
          timer: 2000,
        });

        setAllOrderData((prev) =>
          prev.filter(
            (row) =>
              !(row.record_type === "order" && row.record_id === item.record_id)
          )
        );
      } else {
        throw new Error(response.data?.error || "Unable to delete order");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Unable to delete order",
        text: error?.response?.data?.error || "Something went wrong.",
      });
    }
  };

  const handleCancelShipment = async (item) => {
    if (!item?.shipment_id) return;

    if (![1, 9].includes(Number(item.status))) {
      return;
    }

    const result = await Swal.fire({
      icon: "warning",
      title: "Cancel Shipment?",
      text: `Are you sure you want to cancel shipment ${item.shipment_id}?`,
      input: "text",
      inputLabel: "Cancel reason",
      inputPlaceholder: "Enter cancellation reason",
      showCancelButton: true,
      confirmButtonText: "Cancel Shipment",
      cancelButtonText: "Keep Shipment",
    });

    if (!result.isConfirmed) {
      return;
    }

    if (!result.value?.trim()) {
      Swal.fire({
        icon: "warning",
        text: "Please enter a cancellation reason.",
      });
      return;
    }

    try {
      const userDetail = localStorage.getItem("ship_rocket_user");

      const userData = userDetail ? JSON.parse(userDetail) : {};

      const response = await axios.post(
        `${config.apiUrl}/shipment/shipment_cancel`,
        {
          customer_id: userData.customer_id,
          shipment_id: item.shipment_id,
          cancel_reason: result.value.trim(),
        },
        {
          headers: config.headers,
        }
      );

      if (response.data?.status === "success") {
        Swal.fire({
          toast: true,
          position: "bottom-end",
          icon: "success",
          title: "Shipment cancelled successfully",
          showConfirmButton: false,
          timer: 2000,
        });

        await getOrders();
      } else {
        throw new Error(response.data?.message || "Unable to cancel shipment");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Unable to cancel shipment",
        text: error?.response?.data?.message || "Something went wrong.",
      });
    }
  };

  const handleEditOrder = (sub) => {
    if (!sub) return;

    const items = Array.isArray(sub.items) ? sub.items : [];

    const cleanedItems = items.map((item) => ({
      ...item,
      item_name: item.item_name?.replace(/[^\w\s]/gi, "").trim() || "",
    }));

    const encodedItems = encodeURIComponent(JSON.stringify(cleanedItems));

    const convertToYYYYMMDD = (inputDate) => {
      if (!inputDate) return "";

      const date = new Date(inputDate);

      if (Number.isNaN(date.getTime())) {
        return "";
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    const sender = sub.sender?.[0] || {};
    const receiver = sub.receiver?.[0] || {};
    const returnAddress = sub.return?.[0] || {};

    const query = new URLSearchParams({
      value: sub.mode === "Domestic" ? "0" : "1",

      receiver_name: receiver.name || "",
      receiver_email: receiver.email || "",
      receiver_mobile: receiver.mobile || "",
      receiver_address: receiver.address || "",
      receiver_country: receiver.country || "",
      receiver_country_code: receiver.country_code || "",
      receiver_postal_code: receiver.pincode || "",
      receiver_city: receiver.city || "",
      receiver_state_name: receiver.state || "",

      sender_name: sender.name || "",
      sender_address: sender.address || "",
      sender_country: sender.country || "",
      sender_country_code: sender.country_code || "",
      sender_postal_code: sender.pincode || "",
      sender_state_name: sender.state || "",
      sender_city: sender.city || "",
      sender_address_id: sub.address_id || "",
      sender_city_id: sender.city_id || "",
      sender_mobile: sender.mobile || "",
      sender_email: sender.email || "",

      return_name: returnAddress.name || "",
      return_email: returnAddress.email || "",
      return_mobile: returnAddress.mobile || "",
      return_address: returnAddress.address || "",
      return_country: returnAddress.country || "",
      return_country_code: returnAddress.country_code || "",
      return_postal_code: returnAddress.pincode || "",
      return_city: returnAddress.city || "",
      return_state_name: returnAddress.state || "",

      mode: sub.mode || "",
      items: encodedItems,
      shipment_type: sub.type || "",
      insurance: sub.insurance_amount || 0,

      order_id: sub.order_number || "",

      order_date: convertToYYYYMMDD(sub.order_date),

      weight: sub.total_weight || 0,
      height: sub.height || 0,
      width: sub.width || 0,
      length: sub.length || 0,

      cod_amount: sub.cod_amount || 0,

      payment_mode: sub.payment_mode || "",

      store_id: sub.store_id || "",

      channel_name: sub.channel_name || "",

      volumetric_weight: sub.volumetric_weight || 0,

      dead_weight: sub.dead_weight || 0,

      receiver_state_id: receiver.state_id || "",

      receiver_city_id: receiver.city_id || "",

      moving_type: sub.moving_type || "",
    });

    window.location.href = `/create_order?${query.toString()}`;
  };

  const handleCloneOrder = async (sub) => {
    if (!sub) return;

    try {
      const userDetail = localStorage.getItem("ship_rocket_user");

      const userData = userDetail ? JSON.parse(userDetail) : {};

      const sender = sub.sender?.[0] || {};
      const receiver = sub.receiver?.[0] || {};
      const returnAddress = sub.return?.[0] || {};

      const items = Array.isArray(sub.items) ? sub.items : [];

      const payload = {
        sender_name: sender.name || "",
        sender_mobile: sender.mobile || "",
        sender_email: sender.email || "",
        sender_address: sender.address || "",
        sender_city: sender.city || "",
        sender_city_id: sender.city_id || "",
        sender_state_name: sender.state || "",
        sender_country_name: sender.country || "",
        sender_country_code: sender.country_code || "",
        sender_postal_code: sender.pincode || "",

        receiver_name: receiver.name || "",
        receiver_mobile: receiver.mobile || "",
        receiver_email: receiver.email || "",
        receiver_address: receiver.address || "",
        receiver_city: receiver.city || "",
        receiver_country: receiver.country || "",
        receiver_country_code: receiver.country_code || "",
        receiver_postal_code: receiver.pincode || "",
        receiver_state_name: receiver.state || "",
        receiver_state_id: receiver.state_id || "",
        receiver_city_id: receiver.city_id || "",

        return_name: returnAddress.name || "",
        return_mobile: returnAddress.mobile || "",
        return_email: returnAddress.email || "",
        return_address: returnAddress.address || "",
        return_city: returnAddress.city || "",
        return_state_name: returnAddress.state || "",
        return_country_name: returnAddress.country || "",
        return_country_code: returnAddress.country_code || "",
        return_postal_code: returnAddress.pincode || "",

        payment_mode: sub.payment_mode || "",

        shipment_type: sub.type || "",

        cod_amount: sub.cod_amount || 0,

        volumetric_weight: sub.volumetric_weight || 0,

        total_weight: sub.total_weight || 0,

        dead_weight: sub.dead_weight || 0,

        length: sub.length || 0,
        height: sub.height || 0,
        width: sub.width || 0,

        insurance_amount: sub.insurance_amount || 0,

        type: sub.type || "",

        address_id: sub.address_id || "",

        order_id: "",
        order_date: "",

        mode: sub.mode || "Domestic",

        carrier_type: 1,

        order_type: sub.order_type === "Fulfilled" ? 2 : 1,

        moving_type: sub.moving_type || "",

        items,

        customer_id: userData.customer_id,
      };

      payload.item_name = items.map((item) => item.item_name || "");

      payload.item_value = items.map((item) => item.item_value || 0);

      payload.quantity = items.map((item) => item.item_quantity || 0);

      payload.item_sku = items.map((item) => item.item_sku || "");

      const response = await axios.post(
        `${config.apiUrl}/shipment/order_create`,
        payload,
        {
          headers: config.headers,
        }
      );

      if (response.data?.status === true) {
        Swal.fire({
          toast: true,
          position: "bottom-end",
          icon: "success",
          title: "Order cloned successfully.",
          showConfirmButton: false,
          timer: 2500,
        });

        await getOrders();
      } else {
        throw new Error(response.data?.message || "Unable to clone order.");
      }
    } catch (error) {
      console.error("handleCloneOrder error:", error);

      Swal.fire({
        icon: "error",
        title: "Clone failed",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Something went wrong.",
      });
    }
  };
  const handleUpdateStatus = (item) => {
    if (!item?.shipment_id) {
      return;
    }

    // We will connect this to your existing
    // shipment status API/modal here.
    console.log("Update shipment status:", item);
  };
  const handleInvoice = (item) => {
    if (!item?.shipment_id) {
      return;
    }

    // Connect your existing invoice API here.
    console.log("Download invoice:", item);
  };

  const getCourierOffers = async (order) => {
    if (!order) return;

    try {
      setCourierLoading(true);

      const sender = order?.sender?.[0] || {};

      const receiver = order?.receiver?.[0] || {};

      const userDetail = localStorage.getItem("ship_rocket_user");

      const userData = userDetail ? JSON.parse(userDetail) : {};

      const payload = {
        customer_id: order?.customer_id || userData.customer_id,

        from_postal_code: sender.pincode || "",

        from_country_code: sender.country_code || "IN",

        from_city_id: sender.city_id || "",

        to_postal_code: receiver.pincode || "",

        to_country_code: receiver.country_code || "IN",

        weight: order?.total_weight || 0,

        length: order?.length || 0,

        height: order?.height || 0,

        width: order?.width || 0,

        sort_by: order,

        parcel_type: order?.type || "",

        mode: order?.mode || "Domestic",

        payment_mode: order?.payment_mode || "prepaid",

        order_amount: order?.cod_amount || 0,

        carrier_type: 1,
      };

      console.log("shipment_rate_time payload =>", payload);

      const response = await axios.post(
        `${config.apiUrl}/shipment/shipment_rate_time`,
        payload,
        {
          headers: config.headers,
        }
      );

      console.log("shipment_rate_time response =>", response.data);

      if (
        response.data?.status !== "success" &&
        response.data?.status !== true
      ) {
        Swal.fire({
          icon: "error",
          text: response.data?.message || "No courier services available.",
        });

        setCourierOffers([]);
        return;
      }

      const offers = Array.isArray(response.data?.output)
        ? response.data.output
        : [];

      setCourierOffers(offers);
    } catch (error) {
      console.error("shipment_rate_time error =>", error);

      setCourierOffers([]);

      Swal.fire({
        icon: "error",
        title: "Unable to fetch couriers",
        text:
          error?.response?.data?.message ||
          "Something went wrong while fetching courier rates.",
      });
    } finally {
      setCourierLoading(false);
    }
  };
  const getOfferPrice = (offer) => {
    return (
      Number(offer?.total_charges || 0) + Number(offer?.commission_charge || 0)
    );
  };

  const sortedCourierOffers = React.useMemo(() => {
    const offers = Array.isArray(courierOffers) ? [...courierOffers] : [];

    if (courierSort === "cheap") {
      return offers.sort((a, b) => getOfferPrice(a) - getOfferPrice(b));
    }

    // Recommended:
    // preserve API response order.
    return offers;
  }, [courierOffers, courierSort]);

  // const getOfferPaymentBadge = (offer, order) => {
  //   if (order?.payment_mode === "cod") {
  //     return offer?.cod ? "COD" : "No COD";
  //   }

  //   return "PPD";
  // };

  const getOfferPaymentClass = (offer, order) => {
    if (order?.payment_mode === "cod") {
      return offer?.cod ? "cod" : "nocod";
    }

    return "ppd";
  };

  const getOfferLogo = (offer) => {
    if (!offer?.carrierImage) {
      return null;
    }

    return `https://cdn.shipuncle.in/images/${offer.carrierImage}`;
  };

  const shipOrderWithCourier = async (order, offer) => {
    if (!order || !offer) {
      return;
    }

    try {
      setShippingLoading(true);

      const sender = order?.sender?.[0] || {};
      const receiver = order?.receiver?.[0] || {};
      const returnAddress = order?.return?.[0] || {};

      const userDetail = localStorage.getItem("ship_rocket_user");

      const userData = userDetail ? JSON.parse(userDetail) : {};

      const cleanMobile = (value) => {
        const digits = String(value || "").replace(/\D/g, "");

        if (digits.length > 10 && digits.startsWith("91")) {
          return digits.substring(2);
        }

        return digits;
      };

      const items = Array.isArray(order.items) ? order.items : [];

      const payload = {
        sender_name: sender.name || "",
        sender_mobile: cleanMobile(sender.mobile),
        sender_email: sender.email || "",
        sender_address: sender.address || "",
        sender_city: sender.city || "",
        sender_city_id: sender.city_id || "",
        sender_country_name: sender.country || "",
        sender_country_code: sender.country_code || "",
        sender_postal_code: sender.pincode || "",
        sender_state_name: sender.state || "",

        company_name: offer.service_name || "",

        receiver_name: receiver.name || "",
        receiver_mobile: cleanMobile(receiver.mobile),
        receiver_email: receiver.email || "",
        receiver_address: receiver.address || "",
        receiver_city: receiver.city || "",
        receiver_country_name: receiver.country || "",
        receiver_country_code: receiver.country_code || "",
        receiver_postal_code: receiver.pincode || "",
        receiver_state_id: receiver.state_id || "",
        receiver_city_id: receiver.city_id || "",
        receiver_state_name: receiver.state || "",

        return_name: returnAddress.name || "",
        return_mobile: cleanMobile(returnAddress.mobile),
        return_email: returnAddress.email || "",
        return_address: returnAddress.address || "",
        return_city: returnAddress.city || "",
        return_state_name: returnAddress.state || "",
        return_country_name: returnAddress.country || "",
        return_country_code: returnAddress.country_code || "",
        return_postal_code: returnAddress.pincode || "",

        courier_id: offer.courier_id || "",
        product_id: offer.service_provider_id || offer.product_id || "",

        cod_commission: offer.cod_commission || 0,
        discount: offer.discount || 0,

        payment_mode: order.payment_mode || "prepaid",
        shipment_type: order.type || "",
        cod_amount: order.cod_amount || 0,

        weight: order.total_weight || 0,
        total_weight: order.total_weight || 0,

        length: order.length || 0,
        height: order.height || 0,
        width: order.width || 0,

        item_name: "",
        item_value: "",

        product_type_name: offer.product_type_name || "",

        total_amount:
          Number(offer.total_charges || 0) +
          Number(offer.commission_charge || 0),

        tax_amount: 0,

        rate_price: offer.total_charges || 0,

        service_name: offer.service_provider || "",

        carrier_id: offer.carrier_id || "",

        insurance_amount: order.insurance_amount || 0,

        type: order.type || "",

        address_id: order.address_id || "",

        order_id: order.order_number || "",
        order_date: order.order_date || "",

        mode: order.mode || "Domestic",

        store_id: order.store_id || "",
        channel_name: order.channel_name || "",
        channel_id: order.channel_id || "",

        created_by: "Customer",

        volumetric_weight: order.volumetric_weight || 0,

        payment_status: 1,
        payment_type: order.payment_mode === "cod" ? 0 : 1,

        carrier_type: 1,

        order_type: order.order_type === "Fulfilled" ? 2 : 1,

        zone_name: offer.zone_name || "",

        items,

        shopify_order_number: order.shopify_order_number || "",

        moving_type: order.moving_type || "Forward",

        cust_id: order.customer_id || userData.customer_id,
      };

      payload.item_name = items.map((item) => item.item_name || "");

      payload.item_value = items.map((item) => item.item_value || 0);

      payload.quantity = items.map((item) => item.item_quantity || 0);

      const response = await axios.post(
        `${config.apiUrl}/shipment/new_shipment_create`,
        payload,
        {
          headers: config.headers,
        }
      );

      console.log("new_shipment_create response =>", response.data);

      if (response.data?.status !== "success") {
        Swal.fire({
          icon: "error",
          title: "Shipment booking failed",
          text: response.data?.message || "Unable to create shipment.",
        });

        return;
      }

      if (response.data?.status === "success" && response.data?.log_id) {
        const logId = response.data?.log_id;

        if (!logId) {
          Swal.fire({
            icon: "error",
            title: "Shipping task unavailable",
            text: "Shipment was submitted but no shipping log ID was returned.",
          });

          return;
        }

        localStorage.setItem(
          "global_shipping_task",
          JSON.stringify({
            log_id: logId,
            started_at: Date.now(),
            total: 1,
            success_count: 0,
            failed_count: 0,
            processed: 0,
            progress: 0,
            done: false,
          })
        );

        /*
         * Tell the global component immediately.
         */
        window.dispatchEvent(new Event("shipping-task-started"));

        /*
         * Close Ship Now drawer.
         */
        setShipNowOpen(false);
        setShipNowOrder(null);
        setCourierOffers([]);

        /*
         * Refresh Orders.
         */
        setPage(0);

        await getOrders({
          pageNumber: 0,
          rows: rowsPerPage,
          tab: activeTab,
        });
      }
    } catch (error) {
      console.error("new_shipment_create error:", error);

      Swal.fire({
        icon: "error",
        title: "Shipment booking failed",
        text: error?.response?.data?.message || "Something went wrong.",
      });
    } finally {
      setShippingLoading(false);
    }
  };

  const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));

  const currentPage = page + 1;

  const getPageButtons = () => {
    const buttons = [];

    let from = Math.max(1, currentPage - 2);

    let to = Math.min(totalPages, currentPage + 2);

    if (from > 1) {
      buttons.push(1);
    }

    if (from > 2) {
      buttons.push("ellipsis-left");
    }

    for (let i = from; i <= to; i++) {
      buttons.push(i);
    }

    if (to < totalPages - 1) {
      buttons.push("ellipsis-right");
    }

    if (to < totalPages) {
      buttons.push(totalPages);
    }

    return buttons;
  };
  const handlePageChange = (nextPage) => {
    setPage(nextPage);
    setSelectedIds([]);

    getOrders({
      tab: activeTab,
      pageNumber: nextPage,
      rows: rowsPerPage,
    });
  };

  const handleRowsPerPageChange = (value) => {
    const newRowsPerPage = Number(value);

    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setSelectedIds([]);

    getOrders({
      tab: activeTab,
      pageNumber: 0,
      rows: newRowsPerPage,
    });
  };
  const handleJumpToPage = (value) => {
    let targetPage = Number(value);

    if (!Number.isFinite(targetPage)) {
      return;
    }

    targetPage = Math.max(
      1,
      Math.min(targetPage, Math.max(1, Math.ceil(totalCount / rowsPerPage)))
    );

    handlePageChange(targetPage - 1);
  };

  const getCustomerAllocate = () => {
    try {
      const userDetail = localStorage.getItem("ship_rocket_user");

      if (!userDetail) {
        return 0;
      }

      const userData = JSON.parse(userDetail);

      return Number(userData?.allocate || 0);
    } catch (error) {
      return 0;
    }
  };
  const getRowSelectionId = (item) => {
    if (!item) {
      return "";
    }

    /*
     * Always use the same ID everywhere:
     *
     * order    -> order_number
     * shipment -> shipment_id
     */

    if (item.record_type === "shipment") {
      return String(item.shipment_id || item.record_id || item._id || "");
    }

    return String(item.order_number || item.record_id || item._id || "");
  };
  const currentTabRows = getTabRows;
  const rows = getTabRows;
  const selectedIdSet = React.useMemo(() => {
    return new Set(selectedIds.map((id) => String(id)));
  }, [selectedIds]);
  const selectedRows = React.useMemo(() => {
    return getTabRows.filter((item) =>
      selectedIdSet.has(getRowSelectionId(item))
    );
  }, [getTabRows, selectedIdSet]);

  const currentPageIds = React.useMemo(() => {
    return paginatedRows.map((item) => getRowSelectionId(item)).filter(Boolean);
  }, [paginatedRows]);

  const allCurrentPageSelected =
    currentPageIds.length > 0 &&
    currentPageIds.every((id) => selectedIdSet.has(String(id)));

  const someCurrentPageSelected =
    currentPageIds.some((id) => selectedIdSet.has(String(id))) &&
    !allCurrentPageSelected;

  const clearSelection = () => {
    setSelectedIds([]);
  };

  const BULK_ACTIONS = {
    all: ["export"],

    new: ["delete", "warehouse", "dims", "sku", "export", "ship"],

    pua: ["export", "cancel", "print", "manifest"],

    picked_up: ["export", "print", "manifest"],

    in_transit: ["export", "print", "manifest"],

    ofd: ["export", "print", "manifest"],

    delivered: ["export", "print", "manifest"],

    ndr: ["export", "print", "manifest"],

    failed: [],

    rto_transit: ["export", "print", "manifest"],

    rto_delivered: ["export", "print", "manifest"],

    cancelled: ["export", "print", "manifest"],
  };

  const showBulkAction = (action) => {
    return (BULK_ACTIONS[activeTab] || []).includes(action);
  };

  const handleBulkExport = (rows = []) => {
    if (!rows.length) {
      Swal.fire({
        icon: "warning",
        text: "Please select at least one record.",
      });
      return;
    }

    const exportRows = rows.map((item) => ({
      type: item?.record_type || "",
      order_id: item?.order_number || item?.record_id || "",
      awb: item?.carrier_tracking_number || item?.awb || "",
      channel: item?.channel || "",
      status: item?.display_status || "",
      customer: item?.receiver?.[0]?.name || item?.sender?.[0]?.name || "",
      destination: item?.receiver?.[0]?.city || "",
      courier: item?.service_provider || item?.carrier_name || "",
      payment_mode: item?.payment_mode || "",
      cod_amount: item?.cod_amount || 0,
      weight: item?.total_weight || 0,
    }));

    console.log("Bulk export:", exportRows);

    // Put your existing export API here.
  };

  const handleBulkPrintLabels = (rows = []) => {
    if (!rows.length) {
      Swal.fire({
        icon: "warning",
        text: "Please select at least one shipment.",
      });

      return;
    }

    const shipmentIds = rows
      .filter((item) => item?.record_type === "shipment")
      .map((item) => item?.shipment_id)
      .filter(Boolean);

    if (!shipmentIds.length) {
      Swal.fire({
        icon: "warning",
        text: "No valid shipment IDs found in the selected records.",
      });

      return;
    }

    window.open(
      `/print_label?id=${shipmentIds.join(",")}`,
      "_blank",
      "noopener,noreferrer"
    );
  };
  const handleBulkManifest = async (rows = []) => {
    if (!rows.length) {
      Swal.fire({
        icon: "warning",
        text: "Please select at least one shipment.",
      });

      return;
    }

    const shipmentIds = rows
      .filter((item) => item?.record_type === "shipment")
      .map((item) => item?.shipment_id)
      .filter(Boolean);

    if (!shipmentIds.length) {
      Swal.fire({
        icon: "warning",
        text: "No valid shipment IDs found.",
      });

      return;
    }

    console.log("Manifest shipment IDs:", shipmentIds);
    let dataToSend = {};
    const orderString = shipmentIds.join(",");
    dataToSend.find_bulk = orderString;
    let url = config.apiUrl + "/shipment/generate_manifest";

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        if (res.data.status == true) {
          // setisLoading(false)
          window.location.replace("/manifest_list");
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });

          Toast.fire({
            background: "#a61c09",
            type: "unsuccess",
            title: "Something Went Wrong ",
            color: "white",
          });
          // setisLoading(false)
        }
      })
      .catch((error) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });

        Toast.fire({
          background: "#a61c09",
          type: "unsuccess",
          title: "Something Went Wrong ",
          color: "white",
        });
        // setisLoading(false)
      });
  };

  const handleBulkCancelOrder = async (rows = []) => {
    if (activeTab !== "pua") {
      return;
    }

    const shipments = rows.filter(
      (item) =>
        item?.record_type === "shipment" &&
        [1, 9].includes(Number(item?.status))
    );

    if (!shipments.length) {
      Swal.fire({
        icon: "warning",
        text: "No eligible shipments selected.",
      });

      return;
    }

    const result = await Swal.fire({
      icon: "warning",
      title: "Cancel selected shipments?",
      text: `${shipments.length} shipment${
        shipments.length !== 1 ? "s" : ""
      } will be cancelled.`,
      input: "text",
      inputLabel: "Cancel reason",
      inputPlaceholder: "Enter cancellation reason",
      showCancelButton: true,
      confirmButtonText: "Cancel Shipments",
      cancelButtonText: "Keep",
    });

    if (!result.isConfirmed) {
      return;
    }

    const reason = result.value?.trim();

    if (!reason) {
      Swal.fire({
        icon: "warning",
        text: "Please enter a cancellation reason.",
      });

      return;
    }

    try {
      const userDetail = localStorage.getItem("ship_rocket_user");

      const userData = userDetail ? JSON.parse(userDetail) : {};

      const shipmentIds = shipments.map((shipment) => shipment.shipment_id);

      /*
       * One bulk request.
       */
      const response = await axios.post(
        `${config.apiUrl}/shipment/shipment_cancel_bulk`,
        {
          customer_id: userData.customer_id,

          shipment_id: shipmentIds,

          cancel_reason: reason,
        },
        {
          headers: config.headers,
        }
      );

      console.log("shipment_cancel_bulk response =>", response.data);

      if (response.data?.status !== "started" || !response.data?.task_id) {
        throw new Error(
          response.data?.message || "Unable to start bulk cancellation."
        );
      }

      const taskId = response.data.task_id;

      /*
       * Show processing state immediately.
       */
      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "info",
        title: `Cancelling ${shipments.length} shipments...`,
        showConfirmButton: false,
        timer: 2000,
      });

      /*
       * Poll the bulk cancellation task.
       */
      let completed = false;

      while (!completed) {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        try {
          const logResponse = await axios.post(
            `${config.apiUrl}/shipment/cancel_bulk_logs`,
            {
              task_id: taskId,
            },
            {
              headers: config.headers,
            }
          );

          const logData = logResponse.data;

          console.log("bulk cancel logs =>", logData);

          completed =
            logData?.done === true ||
            Number(logData?.completed || 0) >= Number(logData?.total || 0);

          /*
           * Optional: you can connect this to
           * your global progress bar later.
           */
        } catch (pollError) {
          console.error("bulk cancellation polling error:", pollError);

          /*
           * Don't immediately terminate the
           * cancellation process because the
           * backend is still running.
           */
        }
      }

      setSelectedIds([]);

      await getOrders({
        pageNumber: page,
        rows: rowsPerPage,
        tab: activeTab,
      });

      Swal.fire({
        icon: "success",
        title: "Bulk cancellation completed",
        text: `${shipments.length} shipment${
          shipments.length !== 1 ? "s" : ""
        } processed.`,
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("handleBulkCancelOrder error:", error);

      Swal.fire({
        icon: "error",
        title: "Unable to cancel shipments",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong.",
      });
    }
  };

  const handleBulkDelete = async (rows = []) => {
    if (activeTab !== "new") {
      return;
    }

    const orders = rows.filter((item) => item?.record_type === "order");

    if (!orders.length) {
      Swal.fire({
        icon: "warning",
        text: "No orders selected.",
      });

      return;
    }

    const result = await Swal.fire({
      icon: "warning",
      title: "Delete selected orders?",
      text: `${orders.length} order${
        orders.length !== 1 ? "s" : ""
      } will be deleted.`,
      showCancelButton: true,
      confirmButtonText: "Delete Orders",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc3545",
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const userDetail = localStorage.getItem("ship_rocket_user");

      const userData = userDetail ? JSON.parse(userDetail) : {};

      /*
       * Use your existing delete-order API here.
       *
       * Example:
       *
       * await axios.post(
       *   `${config.apiUrl}/shipment/order_delete`,
       *   {
       *      customer_id: userData.customer_id,
       *      order_id: ...
       *   }
       * );
       */

      console.log("Orders to delete:", orders);

      setSelectedIds([]);

      await getOrders({
        pageNumber: page,
        rows: rowsPerPage,
        tab: activeTab,
      });

      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "success",
        title: "Selected orders deleted",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error("handleBulkDelete error:", error);

      Swal.fire({
        icon: "error",
        title: "Delete failed",
        text: error?.response?.data?.message || "Unable to delete orders.",
      });
    }
  };

  const openBulkShipModal = async () => {
    if (!selectedIds?.length) {
      Swal.fire({
        icon: "warning",
        text: "Please select at least one order.",
      });
      return;
    }

    const selectedOrders = allOrderData.filter((item) => {
      const id = String(
        item?.record_type === "order"
          ? item?.order_number || item?.record_id || item?._id
          : item?.shipment_id || item?.record_id || item?._id
      );

      return selectedIds.map(String).includes(id);
    });

    if (!selectedOrders.length) {
      Swal.fire({
        icon: "warning",
        text: "Selected orders could not be found.",
      });
      return;
    }

    let allocate = 0;

    try {
      const savedUser = localStorage.getItem("ship_rocket_user");

      const userData = savedUser ? JSON.parse(savedUser) : {};

      allocate = Number(userData?.allocate || 0);
    } catch (error) {
      console.error("Unable to read allocation:", error);
    }

    setBulkShipOrders(selectedOrders);
    setCustomerAllocate(allocate);
    setSelectedCourier(null);

    /*
     * allocate 0 -> manual only
     * allocate 1/2 -> auto + manual
     */
    // setShipMode(allocate === 0 ? "manual" : "auto");
    setShipMode("manual");
    setShipStep(1);
    setShowShipModal(true);

    setShippingRules([]);

    await getShippingRules();
  };
  const openBulkWarehouseModal = () => {
    if (!selectedRows.length) {
      Swal.fire({
        icon: "warning",
        text: "Please select at least one order.",
      });

      return;
    }

    setSelectedWarehouse("");
    setShowWarehouseModal(true);
  };

  const handleBulkUpdateWarehouse = async () => {
    if (!selectedWarehouse) {
      Swal.fire({
        icon: "warning",
        text: "Please select a warehouse.",
      });

      return;
    }

    const orderIds = selectedRows
      .filter((item) => item?.record_type === "order")
      .map((item) => item?.order_number || item?.record_id || item?.order_id)
      .filter(Boolean);

    if (!orderIds.length) {
      Swal.fire({
        icon: "warning",
        text: "No valid orders selected.",
      });

      return;
    }

    try {
      setBulkActionLoading(true);

      const response = await axios.post(
        `${config.apiUrl}/shipment/bulk_update_warehouse`,
        {
          order_ids: orderIds,
          warehouse_id: selectedWarehouse,
        },
        {
          headers: config.headers,
        }
      );

      if (!response.data?.status) {
        throw new Error(
          response.data?.message || "Unable to update warehouse."
        );
      }

      setShowWarehouseModal(false);
      setSelectedIds([]);

      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "success",
        title: "Warehouse updated successfully",
        showConfirmButton: false,
        timer: 2000,
      });

      await getOrders({
        pageNumber: page,
        rows: rowsPerPage,
        tab: activeTab,
      });
    } catch (error) {
      console.error("handleBulkUpdateWarehouse error =>", error);

      Swal.fire({
        icon: "error",
        title: "Update failed",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to update warehouse.",
      });
    } finally {
      setBulkActionLoading(false);
    }
  };

  const openBulkDimensionsModal = () => {
    if (!selectedRows.length) {
      Swal.fire({
        icon: "warning",
        text: "Please select at least one order.",
      });

      return;
    }

    setBulkWeight("");
    setBulkLength("");
    setBulkWidth("");
    setBulkHeight("");

    setShowDimensionsModal(true);
  };

  const handleBulkUpdateDimensions = async () => {
    const weight = Number(bulkWeight);
    const length = Number(bulkLength);
    const width = Number(bulkWidth);
    const height = Number(bulkHeight);

    if (!Number.isFinite(weight) || weight <= 0) {
      Swal.fire({
        icon: "warning",
        text: "Please enter a valid weight.",
      });

      return;
    }

    if (
      !Number.isFinite(length) ||
      length <= 0 ||
      !Number.isFinite(width) ||
      width <= 0 ||
      !Number.isFinite(height) ||
      height <= 0
    ) {
      Swal.fire({
        icon: "warning",
        text: "Please enter valid dimensions.",
      });

      return;
    }

    const orderIds = selectedRows
      .filter((item) => item?.record_type === "order")
      .map((item) => item?.order_number || item?.record_id || item?.order_id)
      .filter(Boolean);

    if (!orderIds.length) {
      Swal.fire({
        icon: "warning",
        text: "No valid orders selected.",
      });

      return;
    }

    try {
      setBulkActionLoading(true);

      const response = await axios.post(
        `${config.apiUrl}/shipment/bulk_update_dimensions`,
        {
          orders: orderIds,
          weight,
          length,
          width,
          height,
        },
        {
          headers: config.headers,
        }
      );

      if (!response.data?.status) {
        throw new Error(
          response.data?.message || "Unable to update dimensions."
        );
      }

      setShowDimensionsModal(false);
      setSelectedIds([]);

      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "success",
        title: "Weight and dimensions updated",
        showConfirmButton: false,
        timer: 2000,
      });

      await getOrders({
        pageNumber: page,
        rows: rowsPerPage,
        tab: activeTab,
      });
    } catch (error) {
      console.error("handleBulkUpdateDimensions error =>", error);

      Swal.fire({
        icon: "error",
        title: "Update failed",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to update dimensions.",
      });
    } finally {
      setBulkActionLoading(false);
    }
  };

  const openBulkSkuModal = () => {
    if (!selectedRows.length) {
      Swal.fire({
        icon: "warning",
        text: "Please select at least one order.",
      });

      return;
    }

    setBulkSku("");
    setShowSkuModal(true);
  };

  const handleBulkUpdateSku = async () => {
    const sku = String(bulkSku || "").trim();

    if (!sku) {
      Swal.fire({
        icon: "warning",
        text: "Please enter a SKU.",
      });

      return;
    }

    const orderIds = selectedRows
      .filter((item) => item?.record_type === "order")
      .map((item) => item?.order_number || item?.record_id || item?.order_id)
      .filter(Boolean);

    if (!orderIds.length) {
      Swal.fire({
        icon: "warning",
        text: "No valid orders selected.",
      });

      return;
    }

    try {
      setBulkActionLoading(true);

      const response = await axios.post(
        `${config.apiUrl}/shipment/bulk_update_sku`,
        {
          order_ids: orderIds,
          sku,
        },
        {
          headers: config.headers,
        }
      );

      if (!response.data?.status) {
        throw new Error(response.data?.message || "Unable to update SKU.");
      }

      setShowSkuModal(false);
      setSelectedIds([]);

      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "success",
        title: "SKU updated successfully",
        showConfirmButton: false,
        timer: 2000,
      });

      await getOrders({
        pageNumber: page,
        rows: rowsPerPage,
        tab: activeTab,
      });
    } catch (error) {
      console.error("handleBulkUpdateSku error =>", error);

      Swal.fire({
        icon: "error",
        title: "Update failed",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to update SKU.",
      });
    } finally {
      setBulkActionLoading(false);
    }
  };

  const handleStartBulkShipping = async () => {
    if (!bulkShipOrders.length) {
      Swal.fire({
        icon: "warning",
        text: "No orders selected for shipping.",
      });
      return;
    }

    /*
     * Only orders are allowed in this bulk shipping flow.
     */
    const orderIds = bulkShipOrders
      .filter((item) => item?.record_type === "order")
      .map((item) => item?.order_number || item?.record_id || item?.order_id)
      .filter(Boolean);

    if (!orderIds.length) {
      Swal.fire({
        icon: "warning",
        text: "No valid order IDs found.",
      });
      return;
    }

    /*
     * Shipping Rules mode
     */
    if (shipMode === "rule") {
      if (!shippingRules.length) {
        Swal.fire({
          icon: "warning",
          title: "Shipping Rules not configured",
          text: "Please create at least one active Shipping Rule before using this booking option.",
          showCancelButton: true,
          confirmButtonText: "Create Shipping Rule",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/shipping_rules";
          }
        });

        return;
      }
    }

    /*
     * allocate = 0
     * -> manual only
     *
     * allocate = 1 / 2
     * -> auto or manual
     */
    // if (customerAllocate === 0 && shipMode !== "manual") {
    //   setShipMode("manual");
    //   return;
    // }

    /*
     * Manual requires courier selection.
     */
    if (shipMode === "manual" && !selectedCourier) {
      Swal.fire({
        icon: "warning",
        text: "Please select a courier.",
      });
      return;
    }

    try {
      setShippingLoading(true);

      let response;

      /*
       * =====================================================
       * AUTO ALLOCATION
       * =====================================================
       */
      if (shipMode === "auto") {
        response = await axios.post(
          `${config.apiUrl}/shipment/allocate_bulk_shipment_booking`,
          {
            order_id: orderIds,
          },
          {
            headers: config.headers,
          }
        );
      }

      if (shipMode === "rule") {
        response = await axios.post(
          `${config.apiUrl}/shipment/rule_bulk_shipment_booking`,
          {
            order_id: orderIds,
          },
          {
            headers: config.headers,
          }
        );
      }

      /*
       * =====================================================
       * MANUAL COURIER
       * =====================================================
       */
      if (shipMode === "manual") {
        /*
         * Your product/courier API should provide these.
         * The backend bulk API specifically requires:
         *
         * product_id
         * carrier_id
         */
        const productId =
          selectedCourier?.product_id ||
          selectedCourier?.service_provider_id ||
          selectedCourier?.productId ||
          "";

        const carrierId =
          selectedCourier?.carrier_id || selectedCourier?.carrierId || "";

        if (!productId) {
          Swal.fire({
            icon: "warning",
            text: "Selected courier does not have a product ID.",
          });
          return;
        }

        if (!carrierId) {
          Swal.fire({
            icon: "warning",
            text: "Selected courier does not have a carrier ID.",
          });
          return;
        }

        response = await axios.post(
          `${config.apiUrl}/shipment/bulk_shipment_booking`,
          {
            order_id: orderIds,
            product_id: productId,
            carrier_id: carrierId,
          },
          {
            headers: config.headers,
          }
        );
      }

      console.log("Bulk shipment booking response =>", response?.data);

      /*
       * =====================================================
       * VALIDATE RESPONSE
       * =====================================================
       *
       * Both backend booking APIs return:
       *
       * {
       *   log_id,
       *   status: true
       * }
       */
      if (!response?.data?.status || !response?.data?.log_id) {
        throw new Error(response?.data?.message || "Unable to start shipping.");
      }

      const logId = response.data.log_id;

      /*
       * =====================================================
       * CREATE GLOBAL SHIPPING TASK
       * =====================================================
       *
       * Do this BEFORE refreshing Orders so the progress
       * component immediately knows that shipping started.
       */
      const shippingTask = {
        log_id: logId,

        started_at: Date.now(),

        total: orderIds.length,

        success_count: 0,
        failed_count: 0,

        processed: 0,
        progress: 0,

        done: false,

        mode: shipMode,

        courier:
          shipMode === "manual"
            ? selectedCourier?.courier_name ||
              selectedCourier?.name ||
              selectedCourier?.company_name ||
              ""
            : shipMode === "rule"
            ? "Shipping Rules"
            : "Auto",
      };

      localStorage.setItem(
        "global_shipping_task",
        JSON.stringify(shippingTask)
      );

      /*
       * Tell the global ShippingProgressBar.
       */
      window.dispatchEvent(new Event("shipping-task-started"));

      /*
       * =====================================================
       * CLOSE SHIP MODAL
       * =====================================================
       */
      setShowShipModal(false);
      setShipStep(1);
      setSelectedCourier(null);
      setBulkShipOrders([]);

      /*
       * Clear selected rows.
       */
      setSelectedIds([]);

      /*
       * =====================================================
       * REFRESH CURRENT ORDER PAGE
       * =====================================================
       */
      await getOrders({
        pageNumber: page,
        rows: rowsPerPage,
        tab: activeTab,
      });
    } catch (error) {
      console.error("handleStartBulkShipping error =>", error);

      Swal.fire({
        icon: "error",
        title: "Shipping failed",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to start shipping.",
      });
    } finally {
      setShippingLoading(false);
    }
  };

  const renderModalBackdrop = () => (
    <div
      className="modal-backdrop fade show"
      style={{
        zIndex: 1050,
      }}
      onClick={() => {
        setShowWarehouseModal(false);
        setShowDimensionsModal(false);
        setShowSkuModal(false);
        setShowShipModal(false);
      }}
    />
  );
  React.useEffect(() => {
    const handleRetryOrders = (event) => {
      const retryOrders = event?.detail?.orders || [];

      if (!retryOrders.length) {
        return;
      }

      setSelectedIds([]);

      /*
       * Put failed orders into the same
       * Ship Orders modal state.
       */
      setBulkShipOrders(retryOrders);

      /*
       * Determine allocation.
       */
      let allocate = 0;

      try {
        const savedUser = localStorage.getItem("ship_rocket_user");

        const userData = savedUser ? JSON.parse(savedUser) : {};

        allocate = Number(userData?.allocate || 0);
      } catch (error) {
        console.error("Unable to read allocation:", error);
      }

      setCustomerAllocate(allocate);

      // setShipMode(allocate === 0 ? "manual" : "auto");
      setShipMode("manual");
      setSelectedCourier(null);
      setShipStep(1);
      setShowShipModal(true);
    };

    window.addEventListener("shipping-retry-orders", handleRetryOrders);

    return () => {
      window.removeEventListener("shipping-retry-orders", handleRetryOrders);
    };
  }, []);

  return (
    <div>
      <Header>
        <div className="content">
          {/* <!-- ═══════════ PAGE HEADER ═══════════ --> */}
          <div class="ol-header">
            <div class="ol-hd">
              <a
                type="button"
                class="ol-back"
                id="olBack"
                title="Go back"
                href="javascript:window.history.back();"
              >
                <i class="bi bi-arrow-left"></i>
              </a>
              <div class="ol-title">Orders</div>
            </div>
            <div class="ol-actions">
              <div className="ol-daterange">
                <i className="bi bi-calendar-range"></i>

                <input
                  type="date"
                  id="olDateFrom"
                  title="From date"
                  value={dateRange.from}
                  max={dateRange.to}
                  onChange={(e) => handleDateChange("from", e.target.value)}
                />

                <span className="to">to</span>

                <input
                  type="date"
                  id="olDateTo"
                  title="To date"
                  value={dateRange.to}
                  min={dateRange.from}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) => handleDateChange("to", e.target.value)}
                />

                <button
                  type="button"
                  className="ol-range-go"
                  id="olRangeGo"
                  title="Update data"
                  onClick={() => {
                    setPage(0);
                    setSelectedIds([]);

                    getOrders({
                      pageNumber: 0,
                      rows: rowsPerPage,
                      tab: activeTab,
                    });
                  }}
                >
                  <i className="bi bi-arrow-repeat"></i>
                </button>
              </div>
              <span class="ol-actions-sep d-none d-sm-inline-block"></span>
              <a
                type="button"
                class="ol-btn ghost"
                href="/bulk_order_log_detail"
              >
                <i class="bi bi-clock-history"></i> Shipping Logs
              </a>
              <div class="ol-actions-group">
                <a type="button" class="ol-btn primary" href="/create_order">
                  <i class="bi bi-plus-lg"></i> New Order
                </a>
                <div class="dropdown">
                  <button
                    type="button"
                    class="ol-btn ghost ol-icon-btn"
                    id="olMore"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    title="More actions"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul
                    class="dropdown-menu dropdown-menu-end"
                    aria-labelledby="olMore"
                  >
                    <li>
                      <a class="dropdown-item" href="/create_order?view=bulk">
                        Import Bulk Order
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="/warehouse">
                        Pickup Requests
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- ═══════════ STATUS NAVIGATION (sticky) ═══════════ --> */}

          <div className="ol-sticky">
            <div className="ol-status-nav" id="olStatusNav">
              {ORDER_TABS.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  className={`ol-snav ${activeTab === tab.key ? "on" : ""}`}
                  onClick={() => handleTabChange(tab.key)}
                >
                  <i className={`bi ${tab.icon}`}></i>
                  {tab.label}
                  <span className="cnt">{tabCounts[tab.key] || 0}</span>
                </button>
              ))}
            </div>
          </div>

          {/* <!-- ═══════════ ORDER SUMMARY ═══════════ --> */}
          <div className="ol-summary" id="olSummary">
            {ORDER_SUMMARY.map((metric) => (
              <div
                key={metric.key}
                className={`card-base ol-metric ${metric.accent}`}
              >
                <span className="m-label">
                  <i className={`bi ${metric.icon}`}></i>
                  {metric.label}
                </span>

                <span className="m-val">{tabCounts?.[metric.key] ?? 0}</span>
              </div>
            ))}
          </div>

          {/* <!-- ═══════════ SEARCH + ADVANCED FILTERS ═══════════ --> */}
          <div class="card-base ol-search-card">
            <div class="ol-search-row">
              <div class="ol-search" id="olSearch">
                <i class="bi bi-search"></i>
                <input
                  type="text"
                  id="olSearchInput"
                  placeholder="Search AWB, Order ID, customer name, phone, reference no, tracking..."
                  autoComplete="off"
                  spellCheck="false"
                  value={searchInput}
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const value = e.currentTarget.value.trim();

                      setAppliedSearch(value);
                      setPage(0);
                      setSelectedIds([]);

                      getOrders({
                        searchValue: value,
                        filterValues: filters,
                        pageNumber: 0,
                        rows: rowsPerPage,
                        tab: activeTab,
                      });
                    }
                  }}
                />
                <span class="kbd">/</span>
                <div class="ol-suggest" id="olSuggest"></div>
              </div>
              <button
                type="button"
                className={`ol-btn ${showFilters ? "on" : ""}`}
                id="olFilterToggle"
                onClick={() => setShowFilters((prev) => !prev)}
              >
                <i className="bi bi-sliders"></i> Filters
                {filterCount > 0 && (
                  <span className="ol-badge-dot show">{filterCount}</span>
                )}
              </button>
              <button
                type="button"
                className="ol-btn primary"
                id="olApplyFilters"
                onClick={() => {
                  setPage(0);
                  setSelectedIds([]);

                  getOrders({
                    searchValue: appliedSearch,
                    filterValues: filters,
                    pageNumber: 0,
                    rows: rowsPerPage,
                    tab: activeTab,
                  });
                }}
              >
                <i className="bi bi-check2"></i>
                Apply Filters
              </button>
              <button
                type="button"
                className="ol-btn ghost"
                id="olClearFilters"
                onClick={() => {
                  setFilters(emptyFilters);
                  setSearchInput("");
                  setAppliedSearch("");
                  setPage(0);
                  setSelectedIds([]);

                  getOrders({
                    searchValue: "",
                    filterValues: emptyFilters,
                    pageNumber: 0,
                    rows: rowsPerPage,
                    tab: activeTab,
                  });
                }}
              >
                <i className="bi bi-x-circle"></i>
                Clear
              </button>
            </div>
            <div class="ol-hint">
              <span>
                <i class="bi bi-info-circle"></i> Searches across:
              </span>
              <span>AWB</span>
              <span>Order ID</span>
              <span>Customer</span>
              <span>Phone</span>
              <span>Ref No</span>
              <span>Tracking</span>
            </div>

            <div
              className={`ol-filter-grid ${showFilters ? "open" : ""}`}
              id="olFilterGrid"
            >
              <div className="ol-field">
                <label>Warehouse</label>

                <div
                  className={`ol-mselect ${
                    openFilter === "warehouse" ? "open" : ""
                  }`}
                  id="fltWh"
                >
                  <button
                    type="button"
                    className="ol-mselect-btn"
                    onClick={(e) => {
                      e.stopPropagation();

                      setOpenFilter((prev) =>
                        prev === "warehouse" ? null : "warehouse"
                      );
                    }}
                  >
                    <span
                      className={`ms-txt ${
                        filters.warehouse.length === 0 ? "ms-ph" : ""
                      }`}
                    >
                      {filters.warehouse.length === 0
                        ? "Any Warehouse"
                        : filters.warehouse.length === 1
                        ? warehouses.find(
                            (w) =>
                              String(w.address_id) ===
                              String(filters.warehouse[0])
                          )?.warehouse_id ||
                          warehouses.find(
                            (w) =>
                              String(w.address_id) ===
                              String(filters.warehouse[0])
                          )?.warehouse_name ||
                          "1 selected"
                        : `${filters.warehouse.length} selected`}
                    </span>

                    <i className="bi bi-chevron-down"></i>
                  </button>

                  <div className="ol-mselect-menu">
                    {warehouses.map((warehouse) => {
                      const warehouseValue = warehouse.address_id;

                      const warehouseLabel =
                        warehouse.warehouse_id ||
                        warehouse.warehouse_name ||
                        warehouse.full_name ||
                        warehouse.city_name ||
                        "Warehouse";

                      return (
                        <label className="ol-mopt" key={warehouseValue}>
                          <input
                            type="checkbox"
                            value={warehouseValue}
                            checked={filters.warehouse.includes(warehouseValue)}
                            onChange={(e) =>
                              updateMultiSelect(
                                "warehouse",
                                warehouseValue,
                                e.target.checked
                              )
                            }
                          />

                          <span>{warehouseLabel}</span>
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="ol-field">
                <label>Channel</label>

                <div
                  className={`ol-mselect ${
                    openFilter === "channel" ? "open" : ""
                  }`}
                  id="fltChannel"
                >
                  <button
                    type="button"
                    className="ol-mselect-btn"
                    onClick={(e) => {
                      e.stopPropagation();

                      setOpenFilter((prev) =>
                        prev === "channel" ? null : "channel"
                      );
                    }}
                  >
                    <span
                      className={`ms-txt ${
                        filters.channel.length === 0 ? "ms-ph" : ""
                      }`}
                    >
                      {filters.channel.length === 0
                        ? "Any Channel"
                        : filters.channel.length === 1
                        ? filters.channel[0]
                        : `${filters.channel.length} selected`}
                    </span>

                    <i className="bi bi-chevron-down"></i>
                  </button>

                  <div className="ol-mselect-menu">
                    {["Shopify", "WooCommerce", "Direct Sales"].map((value) => (
                      <label className="ol-mopt" key={value}>
                        <input
                          type="checkbox"
                          value={value}
                          checked={filters.channel.includes(value)}
                          onChange={(e) => {
                            updateMultiSelect(
                              "channel",
                              value,
                              e.target.checked
                            );
                          }}
                        />

                        <span>{value}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
              <div className="ol-field">
                <label>Courier Partner</label>

                <div
                  className={`ol-mselect ${
                    openFilter === "courier" ? "open" : ""
                  }`}
                  id="fltCourier"
                >
                  <button
                    type="button"
                    className="ol-mselect-btn"
                    onClick={(e) => {
                      e.stopPropagation();

                      setOpenFilter((prev) =>
                        prev === "courier" ? null : "courier"
                      );
                    }}
                  >
                    <span
                      className={`ms-txt ${
                        filters.courier.length === 0 ? "ms-ph" : ""
                      }`}
                    >
                      {filters.courier.length === 0
                        ? "Any Courier"
                        : filters.courier.length === 1
                        ? filters.courier[0]
                        : `${filters.courier.length} selected`}
                    </span>

                    <i className="bi bi-chevron-down"></i>
                  </button>

                  <div className="ol-mselect-menu">
                    {courierPartners.map((partner) => {
                      const courierValue =
                        partner.product_name ||
                        partner.service_provider ||
                        partner.carrier_name ||
                        partner.courier_name;

                      if (!courierValue) {
                        return null;
                      }

                      return (
                        <label
                          className="ol-mopt"
                          key={`${partner.carrier_id || "carrier"}-${
                            partner.product_id || courierValue
                          }`}
                        >
                          <input
                            type="checkbox"
                            value={courierValue}
                            checked={filters.courier.includes(courierValue)}
                            onChange={(e) =>
                              updateMultiSelect(
                                "courier",
                                courierValue,
                                e.target.checked
                              )
                            }
                          />

                          <span>{courierValue}</span>
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="ol-field">
                <label>Payment Type</label>

                <div
                  className={`ol-mselect ${
                    openFilter === "payment" ? "open" : ""
                  }`}
                  id="fltPay"
                >
                  <button
                    type="button"
                    className="ol-mselect-btn"
                    onClick={(e) => {
                      e.stopPropagation();

                      setOpenFilter((prev) =>
                        prev === "payment" ? null : "payment"
                      );
                    }}
                  >
                    <span
                      className={`ms-txt ${
                        filters.payment_mode.length === 0 ? "ms-ph" : ""
                      }`}
                    >
                      {filters.payment_mode.length === 0
                        ? "Any Payment"
                        : filters.payment_mode.length === 1
                        ? filters.payment_mode[0] === "prepaid"
                          ? "Prepaid"
                          : "COD"
                        : `${filters.payment_mode.length} selected`}
                    </span>

                    <i className="bi bi-chevron-down"></i>
                  </button>

                  <div className="ol-mselect-menu">
                    <label className="ol-mopt">
                      <input
                        type="checkbox"
                        value="prepaid"
                        checked={filters.payment_mode.includes("prepaid")}
                        onChange={(e) =>
                          updateMultiSelect(
                            "payment_mode",
                            e.target.value,
                            e.target.checked
                          )
                        }
                      />
                      <span>Prepaid</span>
                    </label>

                    <label className="ol-mopt">
                      <input
                        type="checkbox"
                        value="cod"
                        checked={filters.payment_mode.includes("cod")}
                        onChange={(e) =>
                          updateMultiSelect(
                            "payment_mode",
                            e.target.value,
                            e.target.checked
                          )
                        }
                      />
                      <span>COD</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="ol-field">
                <label>Order Type</label>

                <div
                  className={`ol-mselect ${
                    openFilter === "orderType" ? "open" : ""
                  }`}
                  id="fltType"
                >
                  <button
                    type="button"
                    className="ol-mselect-btn"
                    onClick={(e) => {
                      e.stopPropagation();

                      setOpenFilter((prev) =>
                        prev === "orderType" ? null : "orderType"
                      );
                    }}
                  >
                    <span
                      className={`ms-txt ${
                        filters.order_type.length === 0 ? "ms-ph" : ""
                      }`}
                    >
                      {filters.order_type.length === 0
                        ? "Any Type"
                        : filters.order_type.length === 1
                        ? filters.order_type[0]
                        : `${filters.order_type.length} selected`}
                    </span>

                    <i className="bi bi-chevron-down"></i>
                  </button>

                  <div className="ol-mselect-menu">
                    <label className="ol-mopt">
                      <input
                        type="checkbox"
                        value="Forward"
                        checked={filters.order_type.includes("Forward")}
                        onChange={(e) =>
                          updateMultiSelect(
                            "order_type",
                            e.target.value,
                            e.target.checked
                          )
                        }
                      />

                      <span>Forward</span>
                    </label>

                    <label className="ol-mopt">
                      <input
                        type="checkbox"
                        value="Reverse"
                        checked={filters.order_type.includes("Reverse")}
                        onChange={(e) =>
                          updateMultiSelect(
                            "order_type",
                            e.target.value,
                            e.target.checked
                          )
                        }
                      />

                      <span>Reverse</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="ol-field">
                <label>Weight Range (kg)</label>
                <div class="ol-range">
                  <input
                    type="number"
                    id="fltWtMin"
                    placeholder="Min"
                    min="0"
                    step="0.1"
                    value={filters.weight_min}
                    onChange={(e) => {
                      setFilters((prev) => ({
                        ...prev,
                        weight_min: e.target.value,
                      }));
                    }}
                  />
                  <span class="to">to</span>
                  <input
                    type="number"
                    id="fltWtMax"
                    placeholder="Max"
                    min="0"
                    step="0.1"
                    value={filters.weight_max}
                    onChange={(e) => {
                      setFilters((prev) => ({
                        ...prev,
                        weight_max: e.target.value,
                      }));
                    }}
                  />
                </div>
              </div>
              <div class="ol-field">
                <label>COD Amount Range (&#8377;)</label>
                <div class="ol-range">
                  <input
                    type="number"
                    id="fltCodMin"
                    placeholder="Min"
                    min="0"
                    step="1"
                    value={filters.cod_min}
                    onChange={(e) => {
                      setFilters((prev) => ({
                        ...prev,
                        cod_min: e.target.value,
                      }));
                    }}
                  />
                  <span class="to">to</span>
                  <input
                    type="number"
                    id="fltCodMax"
                    placeholder="Max"
                    min="0"
                    step="1"
                    value={filters.cod_max}
                    onChange={(e) => {
                      setFilters((prev) => ({
                        ...prev,
                        cod_max: e.target.value,
                      }));
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <!-- ═══════════ BULK ACTION TOOLBAR ═══════════ --> */}
          <div
            className={`card-base ol-toolbar ${
              selectedIds.length > 0 ? "show" : ""
            }`}
            id="olToolbar"
          >
            <span className="tbar-count">
              <span className="n">{selectedIds.length}</span> selected
            </span>

            <span className="sp"></span>

            {/* EXPORT */}
            {showBulkAction("export") && (
              <button
                type="button"
                className="ol-btn"
                onClick={() => handleBulkExport(selectedRows)}
              >
                <i className="bi bi-download"></i>
                Export
              </button>
            )}

            {/* PRINT LABELS */}
            {showBulkAction("print") && (
              <button
                type="button"
                className="ol-btn"
                onClick={() => handleBulkPrintLabels(selectedRows)}
              >
                <i className="bi bi-printer"></i>
                Print Labels
              </button>
            )}

            {/* MANIFEST */}
            {showBulkAction("manifest") && (
              <button
                type="button"
                className="ol-btn"
                onClick={() => handleBulkManifest(selectedRows)}
              >
                <i className="bi bi-collection"></i>
                Manifest
              </button>
            )}

            {/* SHIP ORDER */}
            {showBulkAction("ship") && (
              <button
                type="button"
                className="ol-btn ship"
                onClick={openBulkShipModal}
              >
                <i className="bi bi-send"></i>
                Ship Order
              </button>
            )}

            {/* UPDATE WAREHOUSE */}
            {showBulkAction("warehouse") && (
              <button
                type="button"
                className="ol-btn"
                onClick={openBulkWarehouseModal}
              >
                <i className="bi bi-diagram-3"></i>
                Update Warehouse
              </button>
            )}

            {/* UPDATE DIMENSIONS */}
            {showBulkAction("dims") && (
              <button
                type="button"
                className="ol-btn"
                onClick={openBulkDimensionsModal}
              >
                <i className="bi bi-arrows-angle-expand"></i>
                Update Weight & Dimensions
              </button>
            )}

            {/* UPDATE SKU */}
            {showBulkAction("sku") && (
              <button
                type="button"
                className="ol-btn"
                onClick={openBulkSkuModal}
              >
                <i className="bi bi-upc-scan"></i>
                Update SKU
              </button>
            )}

            {/* CANCEL ORDER */}
            {showBulkAction("cancel") && (
              <button
                type="button"
                className="ol-btn"
                onClick={() => handleBulkCancelOrder(selectedRows)}
              >
                <i className="bi bi-x-octagon"></i>
                Cancel Order
              </button>
            )}

            <button
              type="button"
              className="ol-toolbar-close"
              id="olToolbarClose"
              title="Deselect all"
              onClick={() => setSelectedIds([])}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>

          {/* <!-- ═══════════ DATA TABLE ═══════════ --> */}
          <div class="card-base ol-table-card">
            {/* <!-- loading skeleton --> */}
            <div
              className={`ol-skeleton ${isLoading ? "show" : ""}`}
              id="olSkeleton"
            >
              <div class="ol-sk-row">
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-bar w80"></div>
                <div class="ol-sk-av"></div>
                <div class="ol-sk-bar w60"></div>
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-badge"></div>
                <div class="ol-sk-bar w40"></div>
                <div class="ol-sk-bar w100"></div>
              </div>
              <div class="ol-sk-row">
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-bar w80"></div>
                <div class="ol-sk-av"></div>
                <div class="ol-sk-bar w60"></div>
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-badge"></div>
                <div class="ol-sk-bar w40"></div>
                <div class="ol-sk-bar w100"></div>
              </div>
              <div class="ol-sk-row">
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-bar w80"></div>
                <div class="ol-sk-av"></div>
                <div class="ol-sk-bar w60"></div>
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-badge"></div>
                <div class="ol-sk-bar w40"></div>
                <div class="ol-sk-bar w100"></div>
              </div>
              <div class="ol-sk-row">
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-bar w80"></div>
                <div class="ol-sk-av"></div>
                <div class="ol-sk-bar w60"></div>
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-badge"></div>
                <div class="ol-sk-bar w40"></div>
                <div class="ol-sk-bar w100"></div>
              </div>
              <div class="ol-sk-row">
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-bar w80"></div>
                <div class="ol-sk-av"></div>
                <div class="ol-sk-bar w60"></div>
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-badge"></div>
                <div class="ol-sk-bar w40"></div>
                <div class="ol-sk-bar w100"></div>
              </div>
              <div class="ol-sk-row">
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-bar w80"></div>
                <div class="ol-sk-av"></div>
                <div class="ol-sk-bar w60"></div>
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-badge"></div>
                <div class="ol-sk-bar w40"></div>
                <div class="ol-sk-bar w100"></div>
              </div>
              <div class="ol-sk-row">
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-bar w80"></div>
                <div class="ol-sk-av"></div>
                <div class="ol-sk-bar w60"></div>
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-badge"></div>
                <div class="ol-sk-bar w40"></div>
                <div class="ol-sk-bar w100"></div>
              </div>
              <div class="ol-sk-row">
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-bar w80"></div>
                <div class="ol-sk-av"></div>
                <div class="ol-sk-bar w60"></div>
                <div class="ol-sk-bar w100"></div>
                <div class="ol-sk-badge"></div>
                <div class="ol-sk-bar w40"></div>
                <div class="ol-sk-bar w100"></div>
              </div>
            </div>

            <div class="ol-table-scroll ol-desk-table">
              <table class="table ol-table" id="olTable">
                <thead>
                  <tr>
                    <th className="col-sel check-col">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={allCurrentPageSelected}
                        ref={(el) => {
                          if (el) {
                            el.indeterminate = someCurrentPageSelected;
                          }
                        }}
                        onChange={(e) => {
                          const checked = e.target.checked;

                          if (checked) {
                            /*
                             * SELECT ALL ROWS ON CURRENT PAGE
                             */

                            setSelectedIds((prev) => {
                              const existing = new Set(
                                prev.map((id) => String(id))
                              );

                              currentPageIds.forEach((id) => {
                                existing.add(String(id));
                              });

                              return Array.from(existing);
                            });
                          } else {
                            /*
                             * DESELECT ALL ROWS ON CURRENT PAGE
                             */

                            setSelectedIds((prev) => {
                              const pageIdSet = new Set(
                                currentPageIds.map(String)
                              );

                              return prev.filter(
                                (id) => !pageIdSet.has(String(id))
                              );
                            });
                          }
                        }}
                      />
                    </th>
                    <th class="col-id ol-sortable" data-sort="id">
                      <span class="th-inner">
                        Order ID <i class="bi bi-arrow-down-up sort-i"></i>
                      </span>
                    </th>
                    <th class="ol-sortable" data-sort="awb">
                      <span class="th-inner">
                        AWB Number <i class="bi bi-arrow-down-up sort-i"></i>
                      </span>
                    </th>
                    <th>Channel</th>
                    <th>Order Status</th>
                    <th>Customer Details</th>
                    <th>Destination</th>
                    <th>Courier Partner</th>
                    <th>Payment Type</th>
                    <th class="ol-sortable" data-sort="cod">
                      <span class="th-inner">
                        COD Amount <i class="bi bi-arrow-down-up sort-i"></i>
                      </span>
                    </th>
                    <th class="ol-sortable" data-sort="charges">
                      <span class="th-inner">
                        Shipping Charges{" "}
                        <i class="bi bi-arrow-down-up sort-i"></i>
                      </span>
                    </th>
                    <th class="ol-sortable" data-sort="weight">
                      <span class="th-inner">
                        Weight &amp; Size{" "}
                        <i class="bi bi-arrow-down-up sort-i"></i>
                      </span>
                    </th>
                    <th class="col-act">Actions</th>
                  </tr>
                </thead>
                <tbody id="olTBody">
                  {!isLoading &&
                    paginatedRows.map((item) => {
                      const receiver = item?.receiver?.[0] || {};
                      const destination = getDestination(item);

                      const uniqueId = `${item.record_type}:${item.record_id}`;

                      const awb =
                        item?.carrier_tracking_number || item?.awb || "";

                      const warehouse =
                        item?.warehouse_id || item?.warehouse_name || "";

                      const product = item?.items?.[0]?.item_name || "";

                      const dimensions = [
                        item?.length,
                        item?.width,
                        item?.height,
                      ]
                        .map((v) => v ?? 0)
                        .join("x");

                      return (
                        <tr key={uniqueId} data-id={uniqueId}>
                          {/* Select */}
                          <td className="col-sel">
                            <input
                              className="form-check-input row-check"
                              type="checkbox"
                              checked={selectedIdSet.has(
                                getRowSelectionId(item)
                              )}
                              onChange={(e) => {
                                const id = getRowSelectionId(item);

                                if (!id) {
                                  return;
                                }

                                setSelectedIds((prev) => {
                                  const existing = new Set(prev.map(String));

                                  if (e.target.checked) {
                                    existing.add(id);
                                  } else {
                                    existing.delete(id);
                                  }

                                  return Array.from(existing);
                                });
                              }}
                            />
                          </td>

                          {/* Order ID */}
                          <td className="col-id">
                            <span className="ol-id-line">
                              <a
                                className="ol-id-link"
                                onClick={() => openOrderDetails(item)}
                              >
                                {item?.order_number || "—"}
                              </a>

                              {item?.order_number && (
                                <i
                                  className="bi bi-clipboard ol-copy"
                                  title="Copy Order ID"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigator.clipboard?.writeText(
                                      String(item.order_number)
                                    );
                                  }}
                                ></i>
                              )}
                            </span>

                            <span className="ol-sub ol-prod">
                              {item?.items?.[0]?.item_name || ""}
                            </span>

                            <span className="ol-sub">
                              {renderOrderDateTime(item)}
                            </span>
                          </td>

                          {/* AWB */}
                          <td>
                            <span className="ol-mono ol-main">
                              {item?.record_type === "shipment"
                                ? item?.carrier_tracking_number ||
                                  item?.awb ||
                                  "—"
                                : "—"}

                              {(item?.carrier_tracking_number || item?.awb) && (
                                <i
                                  className="bi bi-clipboard ol-copy"
                                  title="Copy AWB"
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    navigator.clipboard?.writeText(
                                      String(
                                        item?.carrier_tracking_number ||
                                          item?.awb ||
                                          ""
                                      )
                                    );
                                  }}
                                ></i>
                              )}
                            </span>

                            <span className="ol-sub">
                              {/* {item?.type || ""} */}
                              Forward
                              {item?.type &&
                              (item?.warehouse_id || item?.warehouse_name)
                                ? " · "
                                : ""}
                              {item?.warehouse_id || item?.warehouse_name || ""}
                            </span>
                          </td>

                          {/* Channel */}
                          <td>{renderChannel(item)}</td>

                          {/* Status */}
                          <td>
                            <span className={`ol-st ${getStatusClass(item)}`}>
                              {getStatusLabel(item)}
                            </span>
                          </td>

                          {/* Customer */}
                          <td>{renderCustomer(item)}</td>

                          {/* Destination */}
                          <td>
                            <span className="ol-main">{destination.city}</span>

                            <span className="ol-sub">
                              {[
                                receiver.state,
                                receiver.zone || item?.zone_name,
                                receiver.pincode,
                              ]
                                .filter(Boolean)
                                .join(" · ")}
                            </span>
                          </td>

                          {/* Courier */}
                          <td>{renderCourier(item)}</td>

                          {/* Payment */}
                          <td>
                            <span
                              className={`ol-st ${
                                item?.payment_mode === "cod" ? "amber" : "blue"
                              }`}
                            >
                              {item?.payment_mode === "cod" ? "COD" : "Prepaid"}
                            </span>
                          </td>

                          {/* COD */}
                          <td className="num">
                            {item?.payment_mode === "cod" ? (
                              <span className="cod-amt">
                                {money(item?.cod_amount)}
                              </span>
                            ) : (
                              <span className="ol-sub">—</span>
                            )}
                          </td>

                          {/* Shipping Charges */}
                          <td className="num">
                            {item?.record_type === "shipment"
                              ? money(
                                  item?.total_charges ??
                                    item?.shipping_charges ??
                                    item?.rate_price ??
                                    item?.total_amount
                                )
                              : ""}
                          </td>

                          {/* Weight */}
                          <td className="num">
                            <span className="ol-main">
                              {Number(
                                item?.total_weight || item?.dead_weight || 0
                              ).toFixed(2)}{" "}
                              kg
                            </span>

                            <span className="ol-sub">
                              Vol{" "}
                              {Number(item?.volumetric_weight || 0).toFixed(2)}{" "}
                              kg
                            </span>

                            <span className="ol-sub ol-dims">
                              {dimensions} cm
                            </span>
                          </td>

                          {/* Actions */}
                          <td className="col-act">
                            {activeTab === "new" &&
                            item?.record_type === "order" ? (
                              <div className="d-flex align-items-center gap-1">
                                {/* Ship Now */}
                                <button
                                  type="button"
                                  className="ol-btn ship-now-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openShipNow(item);
                                  }}
                                >
                                  <i className="bi bi-send-fill"></i>
                                  Ship Now
                                </button>

                                {/* Actions */}
                                <div className="ol-more">
                                  <button
                                    type="button"
                                    className="ol-more-btn"
                                    title="Actions"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      openActionMenu(item, e);
                                    }}
                                  >
                                    <i className="bi bi-three-dots-vertical"></i>
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="ol-more">
                                <button
                                  type="button"
                                  className="ol-more-btn"
                                  title="Actions"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openActionMenu(item, e);
                                  }}
                                >
                                  <i className="bi bi-three-dots-vertical"></i>
                                </button>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>

          {/* <!-- ═══════════ EMPTY STATE ═══════════ --> */}
          <div
            className={`card-base ol-empty ${
              !isLoading && paginatedRows.length === 0 ? "show" : ""
            }`}
            id="olEmpty"
          >
            <div class="ol-empty-ico">
              <i class="bi bi-box-seam"></i>
            </div>
            <h4>No orders found</h4>
            <p id="olEmptyMsg">
              We couldn't find any orders matching your current filters. Try
              adjusting the search or filter criteria.
            </p>
            <div class="ol-empty-acts">
              {/* <button type="button" class="ol-btn" id="olEmptyReset">
                <i class="bi bi-arrow-counterclockwise"></i> Reset Filters
              </button> */}
              <a
                type="button"
                class="ol-btn primary"
                id="olEmptyNew"
                href="/create_order"
              >
                <i class="bi bi-plus-lg"></i> New Order
              </a>
            </div>
          </div>

          {/* <!-- ═══════════ MOBILE CARDS ═══════════ --> */}
          <div class="ol-mob-list" id="olMobList"></div>

          {/* <!-- ═══════════ PAGINATION ═══════════ --> */}
          <div className="ol-pager" id="olPager">
            <div className="ol-pager-info">
              Showing{" "}
              <b>
                {totalCount > 0 ? page * rowsPerPage + 1 : 0}–
                {Math.min((page + 1) * rowsPerPage, totalCount)}
              </b>{" "}
              of <b>{totalCount}</b> orders
            </div>

            <div className="ol-pager-nav">
              <button
                type="button"
                className="ol-pg nav-ic"
                disabled={page <= 0}
                onClick={() => handlePageChange(page - 1)}
              >
                <i className="bi bi-chevron-left"></i>
              </button>

              {getPageButtons().map((item, index) => {
                if (item === "ellipsis-left" || item === "ellipsis-right") {
                  return (
                    <span
                      key={`${item}-${index}`}
                      className="ol-pg"
                      style={{
                        pointerEvents: "none",
                      }}
                    >
                      …
                    </span>
                  );
                }

                return (
                  <button
                    key={item}
                    type="button"
                    className={`ol-pg ${item === currentPage ? "on" : ""}`}
                    onClick={() => handlePageChange(item - 1)}
                  >
                    {item}
                  </button>
                );
              })}

              <button
                type="button"
                className="ol-pg nav-ic"
                disabled={page >= totalPages - 1}
                onClick={() => handlePageChange(page + 1)}
              >
                <i className="bi bi-chevron-right"></i>
              </button>
            </div>

            <div className="ol-pager-right">
              <div className="rpp">
                Rows per page{" "}
                <select
                  id="olRpp"
                  value={rowsPerPage}
                  onChange={(e) => handleRowsPerPageChange(e.target.value)}
                >
                  {[5, 10, 25, 50].map((n) => (
                    <option key={n} value={n}>
                      {n}
                    </option>
                  ))}
                </select>
              </div>

              <div className="jump">
                Page{" "}
                <input
                  type="number"
                  id="olJump"
                  min="1"
                  max={totalPages}
                  value={currentPage}
                  onChange={(e) => handleJumpToPage(e.target.value)}
                />{" "}
                of {totalPages}
              </div>
            </div>
          </div>

          {/* <!-- ═══════════ BULK ACTION MODALS ═══════════ --> */}

          {/* <!-- Update Warehouse --> */}
          {showWarehouseModal && (
            <>
              {/* {renderModalBackdrop()} */}
              <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1050 }}
                onClick={() => setShowWarehouseModal(false)}
              />

              <div
                className="modal fade show ol-bulk-modal"
                id="olModalWh"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                style={{
                  display: "block",
                  position: "fixed",
                  inset: 0,
                  zIndex: 1060,
                  overflowY: "auto",
                }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <div>
                        <h5 className="modal-title">
                          <i className="bi bi-diagram-3"></i> Update Warehouse
                        </h5>

                        <p className="ol-bulk-sub">
                          {selectedRows.length} order
                          {selectedRows.length !== 1 ? "s" : ""} selected
                        </p>
                      </div>

                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowWarehouseModal(false)}
                      />
                    </div>

                    <div className="modal-body">
                      <label className="ol-bfield">
                        Select Warehouse <span className="req">*</span>
                      </label>

                      <select
                        className="form-select"
                        value={selectedWarehouse}
                        onChange={(e) => setSelectedWarehouse(e.target.value)}
                      >
                        <option value="">Select warehouse</option>

                        {warehouses.map((warehouse) => (
                          <option
                            key={
                              warehouse?.address_id ||
                              warehouse?.warehouse_id ||
                              warehouse?._id
                            }
                            value={
                              warehouse?.address_id ||
                              warehouse?.warehouse_id ||
                              warehouse?._id
                            }
                          >
                            {warehouse?.warehouse_id || "Warehouse"} -{" "}
                            {warehouse?.address}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => setShowWarehouseModal(false)}
                      >
                        Cancel
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={bulkActionLoading || !selectedWarehouse}
                        onClick={handleBulkUpdateWarehouse}
                      >
                        {bulkActionLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Updating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check2"></i> Update Warehouse
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* <!-- Update Weight & Dimensions --> */}
          {showDimensionsModal && (
            <>
              <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1050 }}
                onClick={() => setShowDimensionsModal(false)}
              />

              <div
                className="modal fade show ol-bulk-modal"
                id="olModalDims"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                style={{
                  display: "block",
                  position: "fixed",
                  inset: 0,
                  zIndex: 1060,
                  overflowY: "auto",
                }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <div>
                        <h5 className="modal-title">
                          <i className="bi bi-arrows-angle-expand"></i> Update
                          Weight & Dimensions
                        </h5>

                        <p className="ol-bulk-sub">
                          {selectedRows.length} order
                          {selectedRows.length !== 1 ? "s" : ""} selected
                        </p>
                      </div>

                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowDimensionsModal(false)}
                      />
                    </div>

                    <div className="modal-body">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="ol-bfield">
                            Weight (kg) <span className="req">*</span>
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            min="0"
                            step="0.01"
                            value={bulkWeight}
                            onChange={(e) => setBulkWeight(e.target.value)}
                            placeholder="Enter weight"
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="ol-bfield">
                            Length (cm) <span className="req">*</span>
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            min="0"
                            step="0.1"
                            value={bulkLength}
                            onChange={(e) => setBulkLength(e.target.value)}
                            placeholder="Length"
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="ol-bfield">
                            Width (cm) <span className="req">*</span>
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            min="0"
                            step="0.1"
                            value={bulkWidth}
                            onChange={(e) => setBulkWidth(e.target.value)}
                            placeholder="Width"
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="ol-bfield">
                            Height (cm) <span className="req">*</span>
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            min="0"
                            step="0.1"
                            value={bulkHeight}
                            onChange={(e) => setBulkHeight(e.target.value)}
                            placeholder="Height"
                          />
                        </div>
                      </div>

                      <div className="ol-ship-note mt-3">
                        <i className="bi bi-info-circle"></i>

                        <span>
                          These values will be applied to all selected orders.
                        </span>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => setShowDimensionsModal(false)}
                      >
                        Cancel
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={bulkActionLoading}
                        onClick={handleBulkUpdateDimensions}
                      >
                        {bulkActionLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Updating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check2"></i> Update Dimensions
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* <!-- Update SKU --> */}
          {showSkuModal && (
            <>
              <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1050 }}
                onClick={() => setShowSkuModal(false)}
              />

              <div
                className="modal fade show ol-bulk-modal"
                id="olModalSku"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                style={{
                  display: "block",
                  position: "fixed",
                  inset: 0,
                  zIndex: 1060,
                  overflowY: "auto",
                }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <div>
                        <h5 className="modal-title">
                          <i className="bi bi-upc-scan"></i> Update SKU
                        </h5>

                        <p className="ol-bulk-sub">
                          {selectedRows.length} order
                          {selectedRows.length !== 1 ? "s" : ""} selected
                        </p>
                      </div>

                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowSkuModal(false)}
                      />
                    </div>

                    <div className="modal-body">
                      <label className="ol-bfield">
                        SKU <span className="req">*</span>
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        value={bulkSku}
                        onChange={(e) => setBulkSku(e.target.value)}
                        placeholder="Enter SKU"
                        maxLength={100}
                        autoComplete="off"
                      />

                      <div className="ol-ship-note mt-3">
                        <i className="bi bi-info-circle"></i>

                        <span>
                          This SKU will be applied to all items in the selected
                          orders.
                        </span>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => setShowSkuModal(false)}
                      >
                        Cancel
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={bulkActionLoading || !bulkSku.trim()}
                        onClick={handleBulkUpdateSku}
                      >
                        {bulkActionLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Updating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check2"></i> Update SKU
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {showShipModal && (
            <>
              <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1050 }}
                onClick={() => setShowShipModal(false)}
              />

              <div
                className="modal fade show ol-bulk-modal ol-ship-modal"
                id="olModalShip"
                tabIndex="-1"
                aria-hidden="false"
                role="dialog"
                aria-modal="true"
                style={{
                  display: "block",
                  position: "fixed",
                  inset: 0,
                  zIndex: 1060,
                  overflowY: "auto",
                }}
              >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                  <div className="modal-content">
                    {/* ================= HEADER ================= */}

                    <div className="modal-header">
                      <div>
                        <h5 className="modal-title">
                          <i className="bi bi-send-check"></i> Ship Orders
                        </h5>

                        <p className="ol-bulk-sub" id="olShipCount">
                          {bulkShipOrders.length} order
                          {bulkShipOrders.length !== 1 ? "s" : ""} selected
                        </p>
                      </div>

                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => setShowShipModal(false)}
                      />
                    </div>

                    {/* ================= BODY ================= */}

                    <div className="modal-body">
                      {/* STEPS */}

                      <div className="ol-ship-steps">
                        <div
                          className={`ol-ship-step ${
                            shipStep === 1 ? "on" : ""
                          }`}
                          data-step="1"
                        >
                          <span className="ol-ship-step-n">1</span>

                          <span className="ol-ship-step-tx">
                            <b>Shipping Mode</b>
                            <small>Auto or manual</small>
                          </span>
                        </div>

                        <span className="ol-ship-step-line"></span>

                        <div
                          className={`ol-ship-step ${
                            shipStep === 2 ? "on" : ""
                          }`}
                          data-step="2"
                        >
                          <span className="ol-ship-step-n">2</span>

                          <span className="ol-ship-step-tx">
                            <b>Confirm & Ship</b>
                            <small>Review and start</small>
                          </span>
                        </div>
                      </div>

                      {/* SUMMARY */}

                      <div
                        className="ol-ship-summary"
                        id="olShipSummary"
                        hidden={shipStep !== 2}
                      >
                        <div className="ol-ship-sum">
                          <b>{bulkShipOrders.length}</b>
                          <span>Orders</span>
                        </div>

                        <div className="ol-ship-sum">
                          <b>
                            ₹
                            {bulkShipOrders
                              .reduce(
                                (sum, item) =>
                                  sum + Number(item?.cod_amount || 0),
                                0
                              )
                              .toLocaleString("en-IN")}
                          </b>
                          <span>COD Total</span>
                        </div>

                        <div className="ol-ship-sum">
                          <b>
                            {bulkShipOrders
                              .reduce(
                                (sum, item) =>
                                  sum + Number(item?.total_weight || 0),
                                0
                              )
                              .toFixed(2)}{" "}
                            kg
                          </b>
                          <span>Total Weight</span>
                        </div>
                      </div>

                      {/* =================================================
                STEP 1 — SHIPPING MODE
                ================================================= */}

                      {shipStep === 1 && (
                        <div className="ol-ship-view" data-view="mode">
                          <div className="ol-mode-grid">
                            {/* AUTO — ONLY ALLOCATE 1/2 */}

                            {/* {customerAllocate !== 0 && (
                              <div
                                className={`ol-mode-card ${
                                  shipMode === "auto" ? "on" : ""
                                }`}
                                data-mode="auto"
                                onClick={() => setShipMode("auto")}
                              >
                                <span className="ol-mode-radio"></span>

                                <span className="ol-mode-ic">
                                  <i className="bi bi-magic"></i>
                                </span>

                                <span className="ol-mode-tx">
                                  <span className="ol-mode-title">
                                    Auto Allocation{" "}
                                    <em className="ol-mode-rec">Recommended</em>
                                  </span>

                                  <span className="ol-mode-desc">
                                    System picks the best courier per order
                                    based on cost, performance, and
                                    serviceability.
                                  </span>

                                  <span className="ol-mode-feat">
                                    <i className="bi bi-check2"></i>
                                    Lowest cost per order
                                  </span>

                                  <span className="ol-mode-feat">
                                    <i className="bi bi-check2"></i>
                                    Fastest delivery ETA
                                  </span>
                                </span>
                              </div>
                            )} */}

                            {/* SHIPPING RULE */}
                            <div
                              className={`ol-mode-card ${
                                shipMode === "rule" ? "on" : ""
                              } ${
                                shippingRules.length === 0 ? "disabled" : ""
                              }`}
                              data-mode="rule"
                              onClick={() => {
                                if (shippingRules.length === 0) {
                                  return;
                                }

                                setShipMode("rule");
                                setSelectedCourier(null);
                              }}
                            >
                              <span className="ol-mode-radio"></span>

                              <span className="ol-mode-ic">
                                <i className="bi bi-diagram-3"></i>
                              </span>

                              <span className="ol-mode-tx">
                                <span className="ol-mode-title">
                                  Book with Shipping Rules
                                </span>

                                {shippingRules.length > 0 ? (
                                  <>
                                    <span className="ol-mode-desc">
                                      Use your configured Shipping Rules to
                                      automatically select the appropriate
                                      shipping product.
                                    </span>

                                    <span className="ol-mode-feat">
                                      <i className="bi bi-check2"></i>
                                      {shippingRules.length} active rule
                                      {shippingRules.length !== 1 ? "s" : ""}
                                    </span>

                                    <span className="ol-mode-feat">
                                      <i className="bi bi-check2"></i>
                                      Rules evaluated by priority
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <span className="ol-mode-desc">
                                      No active Shipping Rules are configured.
                                    </span>

                                    <span className="ol-mode-feat">
                                      <i className="bi bi-lock"></i>
                                      Create a Shipping Rule first
                                    </span>
                                  </>
                                )}
                              </span>
                            </div>

                            {/* MANUAL */}

                            <div
                              className={`ol-mode-card ${
                                shipMode === "manual" ? "on" : ""
                              }`}
                              data-mode="manual"
                              onClick={() => setShipMode("manual")}
                            >
                              <span className="ol-mode-radio"></span>

                              <span className="ol-mode-ic">
                                <i className="bi bi-truck"></i>
                              </span>

                              <span className="ol-mode-tx">
                                <span className="ol-mode-title">
                                  Manual Courier
                                </span>

                                <span className="ol-mode-desc">
                                  Choose a single courier to ship all selected
                                  orders.
                                </span>

                                <span className="ol-mode-feat">
                                  <i className="bi bi-check2"></i>
                                  Pick your own courier
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* =================================================
                STEP 2 — AUTO
                ================================================= */}

                      {/* {shipStep === 2 && shipMode === "auto" && (
                        <div className="ol-ship-view" data-view="auto">
                          <div className="ol-ship-note">
                            <i className="bi bi-magic"></i>

                            <span>
                              <b>Auto Allocation Enabled</b> Best courier will
                              be assigned per order based on cost and delivery
                              performance.
                            </span>
                          </div>

                          <div className="ol-ship-orders" id="olShipOrders">
                            {bulkShipOrders.map((item, index) => (
                              <div
                                className="ol-ship-order"
                                key={
                                  item?.order_number || item?.record_id || index
                                }
                              >
                                <div>
                                  <b>
                                    {item?.order_number ||
                                      item?.record_id ||
                                      "—"}
                                  </b>

                                  <small>
                                    {item?.receiver?.[0]?.city ||
                                      item?.destination?.city ||
                                      "—"}
                                  </small>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )} */}

                      {/* =================================================
                STEP 2 — MANUAL
                ================================================= */}

                      {shipStep === 2 && shipMode === "manual" && (
                        <div className="ol-ship-view" data-view="manual">
                          <label className="ol-bfield">
                            Select Courier <span className="req">*</span>
                          </label>

                          <div className="ol-courier-grid" id="olShipCouriers">
                            {courierPartners.map((courier, index) => {
                              const courierId = String(
                                courier?.product_id ||
                                  courier?.id ||
                                  courier?._id ||
                                  index
                              );

                              const selected =
                                String(
                                  selectedCourier?.product_id ||
                                    selectedCourier?.id ||
                                    selectedCourier?._id ||
                                    ""
                                ) === courierId;

                              return (
                                <div
                                  key={courierId}
                                  className={`ol-mode-card ${
                                    selected ? "on" : ""
                                  }`}
                                  onClick={() => setSelectedCourier(courier)}
                                >
                                  <span className="ol-mode-radio"></span>

                                  <span className="ol-mode-ic">
                                    <i className="bi bi-truck"></i>
                                  </span>

                                  <span className="ol-mode-tx">
                                    <span className="ol-mode-title">
                                      {courier?.product_name ||
                                        courier?.name ||
                                        courier?.company_name ||
                                        "Courier"}
                                    </span>
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* ================= FOOTER ================= */}

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light"
                        id="olShipCancel"
                        onClick={() => setShowShipModal(false)}
                      >
                        Cancel
                      </button>

                      {shipStep === 2 && (
                        <button
                          type="button"
                          className="btn btn-light"
                          id="olShipBack"
                          onClick={() => setShipStep(1)}
                        >
                          <i className="bi bi-arrow-left"></i> Back
                        </button>
                      )}

                      {shipStep === 1 && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          id="olShipContinue"
                          disabled={shippingLoading}
                          onClick={() => {
                            if (shipMode === "rule") {
                              handleStartBulkShipping();
                              return;
                            }

                            setShipStep(2);
                          }}
                        >
                          {shippingLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Shipping...
                            </>
                          ) : shipMode === "rule" ? (
                            <>
                              <i className="bi bi-send"></i> Ship Orders
                            </>
                          ) : (
                            <>
                              Continue <i className="bi bi-arrow-right"></i>
                            </>
                          )}
                        </button>
                      )}

                      {shipStep === 2 && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          id="olShipGo"
                          disabled={shippingLoading}
                          onClick={handleStartBulkShipping}
                        >
                          {shippingLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Shipping...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-send"></i>{" "}
                              <span id="olShipGoLbl">Ship Orders</span>
                            </>
                          )}
                        </button>
                      )}
                    </div>
                    {/* <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light"
                        id="olShipCancel"
                        onClick={() => setShowShipModal(false)}
                      >
                        Cancel
                      </button>

                      {shipStep === 2 && (
                        <button
                          type="button"
                          className="btn btn-light"
                          id="olShipBack"
                          onClick={() => setShipStep(1)}
                        >
                          <i className="bi bi-arrow-left"></i> Back
                        </button>
                      )}

                      {shipStep === 1 && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          id="olShipContinue"
                          onClick={() => {
                            setShipStep(2);
                          }}
                        >
                          Continue <i className="bi bi-arrow-right"></i>
                        </button>
                      )}

                      {shipStep === 2 && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          id="olShipGo"
                          disabled={shippingLoading}
                          onClick={handleStartBulkShipping}
                        >
                          {shippingLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Shipping...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-send"></i>{" "}
                              <span id="olShipGoLbl">
                                {shipMode === "auto"
                                  ? "Start Shipping"
                                  : "Ship Orders"}
                              </span>
                            </>
                          )}
                        </button>
                      )}
                     
                    </div> */}
                  </div>
                </div>
              </div>
            </>
          )}

          {/* <!-- ═══════════ SHIPMENT DETAILS OFF-CANVAS ═══════════ --> */}
          <div
            className={`offcanvas offcanvas-end ol-drawer ${
              detailDrawerOpen ? "show" : ""
            }`}
            id="olShipDrawer"
            tabIndex="-1"
            aria-labelledby="olDrTitle"
            style={{
              visibility: detailDrawerOpen ? "visible" : "hidden",
            }}
          >
            {/* HEADER */}
            <div className="offcanvas-header ol-drawer-head">
              <div className="ol-drawer-hero">
                <div className="ol-drawer-courier">
                  {selectedOrder?.record_type === "shipment"
                    ? getDrawerCourier(selectedOrder)
                    : "Order"}
                </div>

                <div className="ol-drawer-awb">
                  {selectedOrder?.record_type === "shipment"
                    ? selectedOrder?.carrier_tracking_number ||
                      selectedOrder?.awb ||
                      "—"
                    : selectedOrder?.order_number || "—"}

                  {selectedOrder?.record_type === "shipment" &&
                    (selectedOrder?.carrier_tracking_number ||
                      selectedOrder?.awb) && (
                      <i
                        className="bi bi-clipboard ol-copy"
                        title="Copy AWB"
                        onClick={() => {
                          navigator.clipboard?.writeText(
                            String(
                              selectedOrder?.carrier_tracking_number ||
                                selectedOrder?.awb ||
                                ""
                            )
                          );
                        }}
                      />
                    )}
                </div>

                <div className="ol-drawer-meta">
                  <span className="ol-drawer-sub">
                    {selectedOrder?.record_type === "shipment"
                      ? `Order ${selectedOrder?.order_number || ""}${
                          selectedOrder?.type ? ` · ${selectedOrder.type}` : ""
                        }${
                          getDrawerService(selectedOrder) !== "—"
                            ? ` · ${getDrawerService(selectedOrder)}`
                            : ""
                        }`
                      : selectedOrder?.order_number || "—"}
                  </span>
                </div>
              </div>

              <div className="ol-drawer-head-right">
                {selectedOrder && (
                  <span
                    className={`ol-st ol-drawer-status ${getStatusClass(
                      selectedOrder
                    )}`}
                  >
                    {getStatusLabel(selectedOrder)}
                  </span>
                )}

                <button
                  type="button"
                  className="btn-close text-reset"
                  onClick={closeOrderDetails}
                  aria-label="Close"
                />
              </div>
            </div>

            {/* BODY */}
            <div className="offcanvas-body ol-drawer-body">
              {/* OVERVIEW */}
              <div className="ol-drawer-sec">
                <div className="ol-drawer-sec-head">
                  <i className="bi bi-clipboard-data"></i>
                  Overview
                </div>

                <div className="ol-drawer-stats">
                  <div className="od-stat">
                    <div className="od-stat-ic">
                      <i className="bi bi-upc-scan"></i>
                    </div>

                    <div className="od-stat-tx">
                      <span>Payment</span>
                      <b>
                        {selectedOrder ? getDrawerPayment(selectedOrder) : "—"}
                      </b>
                      <small>
                        {selectedOrder?.payment_status
                          ? "Paid"
                          : selectedOrder?.payment_mode === "prepaid"
                          ? "Paid"
                          : ""}
                      </small>
                    </div>
                  </div>

                  <div className="od-stat">
                    <div className="od-stat-ic">
                      <i className="bi bi-box-seam"></i>
                    </div>

                    <div className="od-stat-tx">
                      <span>Weight</span>
                      <b>
                        {selectedOrder ? getDrawerWeight(selectedOrder) : "—"}
                      </b>
                      <small>
                        Vol{" "}
                        {selectedOrder
                          ? getDrawerVolumetricWeight(selectedOrder)
                          : "—"}
                      </small>
                    </div>
                  </div>

                  <div className="od-stat">
                    <div className="od-stat-ic">
                      <i className="bi bi-truck"></i>
                    </div>

                    <div className="od-stat-tx">
                      <span>Courier</span>
                      <b>
                        {selectedOrder ? getDrawerCourier(selectedOrder) : "—"}
                      </b>
                      <small>
                        {selectedOrder ? getDrawerService(selectedOrder) : "—"}
                      </small>
                    </div>
                  </div>

                  <div className="od-stat">
                    <div className="od-stat-ic">
                      <i className="bi bi-geo-alt"></i>
                    </div>

                    <div className="od-stat-tx">
                      <span>Destination</span>
                      <b>
                        {selectedOrder
                          ? getDrawerDestination(selectedOrder).city
                          : "—"}
                      </b>
                      <small>
                        {selectedOrder
                          ? getDrawerDestination(selectedOrder).state
                          : ""}
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              {/* SHIPMENT DETAILS */}
              <div className="ol-drawer-sec">
                <div className="ol-drawer-sec-head">
                  <i className="bi bi-truck"></i>
                  Shipment Details
                </div>

                <div className="ol-drawer-grid">
                  <DrawerRow
                    label="Order Created"
                    value={formatDrawerDateTime(getCreatedDate(selectedOrder))}
                  />

                  <DrawerRow
                    label="AWB Created"
                    value={
                      selectedOrder?.record_type === "shipment"
                        ? formatDrawerDateTime(getAwbCreatedDate(selectedOrder))
                        : "—"
                    }
                  />

                  <DrawerRow
                    label="Courier"
                    value={
                      selectedOrder ? getDrawerCourier(selectedOrder) : "—"
                    }
                  />

                  <DrawerRow
                    label="Service"
                    value={
                      selectedOrder ? getDrawerService(selectedOrder) : "—"
                    }
                  />

                  <DrawerRow
                    label="Warehouse"
                    value={
                      selectedOrder ? getDrawerWarehouse(selectedOrder) : "—"
                    }
                  />

                  <DrawerRow
                    label="Type"
                    value={
                      selectedOrder?.type || selectedOrder?.moving_type || "—"
                    }
                  />

                  <DrawerRow
                    label="Pickup Date"
                    value={
                      selectedOrder?.pickup_date
                        ? formatDrawerDateTime(selectedOrder.pickup_date)
                        : selectedOrder?.pickupDate
                        ? formatDrawerDateTime(selectedOrder.pickupDate)
                        : "—"
                    }
                  />

                  <DrawerRow
                    label="Delivered"
                    value={
                      selectedOrder?.delivery_date
                        ? formatDrawerDateTime(selectedOrder.delivery_date)
                        : "—"
                    }
                  />

                  <DrawerRow
                    label="Payment"
                    value={getDrawerPayment(selectedOrder)}
                  />

                  <DrawerRow
                    label="COD Amount"
                    value={getDrawerCod(selectedOrder)}
                  />

                  <DrawerRow
                    label="Shipping Charges"
                    value={getDrawerCharges(selectedOrder)}
                  />
                </div>
              </div>

              {/* BUYER DETAILS */}
              <div className="ol-drawer-sec">
                <div className="ol-drawer-sec-head">
                  <i className="bi bi-person"></i>
                  Buyer Details
                </div>

                <div className="ol-drawer-grid">
                  <DrawerRow
                    label="Name"
                    value={getDrawerCustomer(selectedOrder).name}
                  />

                  <DrawerRow
                    label="Phone"
                    value={getDrawerCustomer(selectedOrder).phone}
                  />

                  <DrawerRow
                    label="Email"
                    value={getDrawerCustomer(selectedOrder).email}
                  />

                  <DrawerRow
                    label="Company"
                    value={getDrawerCompany(selectedOrder)}
                  />

                  <DrawerRow
                    label="Address"
                    value={[
                      getDrawerCustomer(selectedOrder).address,
                      getDrawerCustomer(selectedOrder).city,
                      getDrawerCustomer(selectedOrder).state,
                      getDrawerCustomer(selectedOrder).pincode,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                    full
                  />
                </div>
              </div>

              {/* PRODUCT DETAILS */}
              <div className="ol-drawer-sec">
                <div className="ol-drawer-sec-head">
                  <i className="bi bi-box-seam"></i>
                  Product Details
                </div>

                <div className="ol-item-wrap">
                  <table className="ol-item-table">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th className="ol-num">SKU</th>
                        <th className="ol-num">Qty</th>
                        <th className="ol-num">Unit Price</th>
                        <th className="ol-num">Total</th>
                      </tr>
                    </thead>

                    <tbody>
                      {getDrawerItems(selectedOrder).length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No product details
                          </td>
                        </tr>
                      ) : (
                        getDrawerItems(selectedOrder).map((product, index) => (
                          <tr key={product?._id || product?.item_sku || index}>
                            <td className="ol-item-name">
                              {product?.item_name || "—"}
                            </td>

                            <td className="ol-num">
                              {product?.item_sku || "—"}
                            </td>

                            <td className="ol-num">
                              {Number(product?.item_quantity || 0)}
                            </td>

                            <td className="ol-num">
                              ₹{Number(product?.item_value || 0).toFixed(2)}
                            </td>

                            <td className="ol-num ol-item-line">
                              ₹{getDrawerItemTotal(product).toFixed(2)}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* TRACKING */}
              <div className="ol-drawer-sec">
                <div className="ol-drawer-sec-head">
                  <i className="bi bi-radar"></i>
                  Tracking History
                </div>

                {selectedOrder?.record_type !== "shipment" ? (
                  <div className="ol-sub">No tracking history available.</div>
                ) : trackingLoading ? (
                  <div className="ol-sub">Loading tracking history...</div>
                ) : trackingHistory.length === 0 ? (
                  <div className="ol-sub">No tracking history available.</div>
                ) : (
                  <div className="ol-timeline">
                    {trackingHistory.map((event, index) => (
                      <div
                        key={event?._id || event?.id || index}
                        className={`ol-tl-item ${event?.state || "done"}`}
                      >
                        <div className="tl-tx">
                          {event?.label ||
                            event?.status ||
                            event?.remark ||
                            event?.activity ||
                            "Tracking update"}
                        </div>

                        {(event?.location ||
                          event?.city ||
                          event?.location_name) && (
                          <div className="tl-loc">
                            <i className="bi bi-geo-alt"></i>{" "}
                            {event?.location ||
                              event?.city ||
                              event?.location_name}
                          </div>
                        )}

                        <div className="tl-time">
                          <i className="bi bi-clock"></i>{" "}
                          {formatDrawerDateTime(
                            event?.timestamp ||
                              event?.created ||
                              event?.date ||
                              event?.event_time
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* FOOTER */}
            {selectedOrder?.record_type === "shipment" && (
              <div className="offcanvas-footer ol-drawer-foot">
                <button
                  type="button"
                  className="ol-btn"
                  onClick={() => handleTrackShipment(selectedOrder)}
                >
                  <i className="bi bi-radar"></i>
                  Track
                </button>

                <button
                  type="button"
                  className="ol-btn"
                  onClick={() => handlePrintLabel(selectedOrder)}
                >
                  <i className="bi bi-tag"></i>
                  Label
                </button>

                <button
                  type="button"
                  className="ol-btn"
                  onClick={() => {
                    console.log("Invoice", selectedOrder);
                  }}
                >
                  <i className="bi bi-receipt"></i>
                  Invoice
                </button>
              </div>
            )}
          </div>

          {detailDrawerOpen && (
            <div
              className="offcanvas-backdrop fade show"
              onClick={closeOrderDetails}
            ></div>
          )}

          {/* <!-- ═══════════ SHIP NOW COURIER COMPARE OFF-CANVAS ═══════════ --> */}
          <div
            className={`offcanvas offcanvas-end ol-drawer ol-ship-now ${
              shipNowOpen ? "show" : ""
            }`}
            id="olShipNowDrawer"
            tabIndex="-1"
            aria-labelledby="osnTitle"
            style={{
              visibility: shipNowOpen ? "visible" : "hidden",
            }}
          >
            {/* HEADER */}
            <div className="offcanvas-header ol-drawer-head">
              <div className="ol-drawer-hero">
                <div className="ol-drawer-courier">Ship Now</div>

                <div className="ol-drawer-awb" id="osnId">
                  {shipNowOrder?.order_number || "—"}
                </div>

                <div className="ol-drawer-meta">
                  <span className="ol-drawer-sub" id="osnSub">
                    Ship to {shipNowOrder?.receiver?.[0]?.city || "—"}
                    {shipNowOrder?.receiver?.[0]?.state
                      ? `, ${shipNowOrder.receiver[0].state}`
                      : ""}
                  </span>
                </div>
              </div>

              <div className="ol-drawer-head-right">
                <button
                  type="button"
                  className="btn-close text-reset"
                  onClick={closeShipNow}
                  disabled={shippingLoading}
                  aria-label="Close"
                />
              </div>
            </div>

            {/* BODY */}
            <div className="offcanvas-body ol-drawer-body">
              {/* ORDER SUMMARY */}
              <div className="osn-order" id="osnOrder">
                <div className="osn-o-prod">
                  {shipNowOrder?.items?.[0]?.item_name || "—"}
                </div>

                <div className="osn-o-sub">
                  <i className="bi bi-geo-alt"></i>{" "}
                  {[
                    shipNowOrder?.receiver?.[0]?.city,
                    shipNowOrder?.receiver?.[0]?.state,
                    shipNowOrder?.receiver?.[0]?.pincode,
                  ]
                    .filter(Boolean)
                    .join(", ")
                    .replace(/, ([^,]+), ([^,]+)$/, ", $1 · $2")}
                </div>

                <div className="osn-o-chips">
                  <span className="osn-o-chip">
                    <i className="bi bi-box"></i>{" "}
                    {Number(shipNowOrder?.total_weight || 0).toFixed(2)} kg
                  </span>

                  <span className="osn-o-chip">
                    <i className="bi bi-arrows-angle-expand"></i> Vol{" "}
                    {Number(shipNowOrder?.volumetric_weight || 0).toFixed(2)} kg
                  </span>

                  <span className="osn-o-chip">
                    {shipNowOrder?.payment_mode === "cod" ? (
                      <>
                        <i className="bi bi-cash-coin"></i> COD{" "}
                        {`₹${Number(shipNowOrder?.cod_amount || 0).toFixed(2)}`}
                      </>
                    ) : (
                      <>
                        <i className="bi bi-credit-card"></i> Prepaid
                      </>
                    )}
                  </span>
                </div>
              </div>

              {/* SORT */}
              <div className="osn-sort">
                <button
                  type="button"
                  className={`osn-sort-btn ${
                    courierSort === "recommended" ? "on" : ""
                  }`}
                  data-sort="recommended"
                  onClick={() => setCourierSort("recommended")}
                >
                  <i className="bi bi-stars"></i>
                  Recommended
                </button>

                <button
                  type="button"
                  className={`osn-sort-btn ${
                    courierSort === "cheap" ? "on" : ""
                  }`}
                  data-sort="cheap"
                  onClick={() => setCourierSort("cheap")}
                >
                  <i className="bi bi-coin"></i>
                  Cheap
                </button>
              </div>

              {/* COURIER LIST */}
              {courierLoading ? (
                <div className="osn-list" id="osnList">
                  <div className="text-center py-4">
                    <div className="spinner-border" role="status"></div>

                    <div className="ol-sub mt-2">
                      Finding available couriers...
                    </div>
                  </div>
                </div>
              ) : sortedCourierOffers.length === 0 ? (
                <div className="osn-list" id="osnList">
                  <div className="text-center py-4">
                    <i className="bi bi-truck fs-2"></i>

                    <div className="mt-2">No courier services available</div>
                  </div>
                </div>
              ) : (
                <div className="osn-list" id="osnList">
                  {sortedCourierOffers.map((offer, index) => {
                    const isFirst = index === 0;

                    const badge = isFirst
                      ? courierSort === "cheap"
                        ? "cheapest"
                        : "best"
                      : "";

                    const logo = getOfferLogo(offer);

                    // const paymentBadge = getOfferPaymentBadge(
                    //   offer,
                    //   shipNowOrder
                    // );

                    const paymentClass = getOfferPaymentClass(
                      offer,
                      shipNowOrder
                    );

                    const price = getOfferPrice(offer);

                    return (
                      <div
                        key={
                          offer?.courier_id ||
                          offer?.carrier_id ||
                          offer?.product_id ||
                          `${offer?.service_provider}-${index}`
                        }
                        className={`osn-card ${badge || ""}`}
                        data-offer={offer?.service_provider || ""}
                      >
                        {/* RIBBON */}
                        {badge && (
                          <span className="osn-ribbon">
                            {badge === "cheapest" ? (
                              <>
                                <i className="bi bi-tag-fill"></i> Cheapest
                              </>
                            ) : (
                              <>
                                <i className="bi bi-stars"></i> Recommended
                              </>
                            )}
                          </span>
                        )}

                        {/* TOP */}
                        <div className="osn-card-top">
                          {/* LOGO */}
                          <span className="osn-logo">
                            {logo ? (
                              <img
                                className="osn-logo-img"
                                src={logo}
                                alt={offer?.service_provider || "Courier"}
                              />
                            ) : (
                              <span className="osn-logo-txt">
                                {(offer?.service_provider || "C").charAt(0)}
                              </span>
                            )}
                          </span>

                          {/* NAME / SERVICE */}
                          <span className="osn-info">
                            <span className="osn-name">
                              {offer?.service_provider || "Courier"}
                            </span>

                            <span className="osn-meta">
                              {offer?.product_type_name ||
                                offer?.service_name ||
                                ""}
                            </span>
                          </span>

                          {/* PAYMENT */}
                          {/* <span className={`osn-pay ${paymentClass}`}>
                            {paymentBadge}
                          </span> */}

                          {/* PRICE */}
                          <span className="osn-price">₹{price.toFixed(0)}</span>
                        </div>

                        {/* SHIP NOW */}
                        <button
                          type="button"
                          className="osn-ship-btn"
                          data-ship-offer={offer?.service_provider || ""}
                          disabled={shippingLoading}
                          onClick={() =>
                            shipOrderWithCourier(shipNowOrder, offer)
                          }
                        >
                          <i className="bi bi-send-fill"></i> Ship Now
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {shipNowOpen && (
            <div
              className="offcanvas-backdrop fade show"
              onClick={() => {
                if (!shippingLoading) {
                  closeShipNow();
                }
              }}
            ></div>
          )}

          {shipNowOpen && (
            <div
              className="offcanvas-backdrop fade show"
              onClick={() => {
                if (!shippingLoading) {
                  closeShipNow();
                }
              }}
            />
          )}
          {actionMenuItem && (
            <div
              className="ol-action-menu"
              style={{
                position: "fixed",
                top: `${actionMenuPosition.top}px`,
                left: `${actionMenuPosition.left}px`,
                zIndex: 99999,
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {getRowActions(actionMenuItem).map((action, index) => {
                // ==========================================
                // SECTION HEADING
                // ==========================================

                if (action.type === "heading") {
                  return (
                    <div key={`heading-${index}`} className="mm-head">
                      {action.label}
                    </div>
                  );
                }

                // ==========================================
                // SEPARATOR
                // ==========================================

                if (action.type === "separator") {
                  return <div key={`separator-${index}`} className="mm-sep" />;
                }

                // ==========================================
                // ACTION
                // ==========================================

                return (
                  <a
                    href="#"
                    key={action.key}
                    className={action.danger ? "danger" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      handleRowAction(action.key, actionMenuItem);
                    }}
                  >
                    <i className={`bi ${action.icon}`}></i>

                    <span>{action.label}</span>
                  </a>
                );
              })}
            </div>
          )}
        </div>
      </Header>

      <Footer />
    </div>
  );
};

export default Orders;
